<template>
  <div>
    <div class="inline-flex pb-6">
      <h1 class="inline-flex pr-4">
        Customs Permit (API) Component
        <p class="pl-4">|</p>
      </h1>
      <p class="pr-4"></p>
      <!-- <vs-button
        color="#5b3cc4"
        type="filled"
        icon="cloud_upload"
        @click="upload"
        >Upload</vs-button
      > -->
      <p class="pr-4"></p>
      <vs-button color="#5b3cc4" type="filled" icon="search" @click="grid">List</vs-button>
      <p class="pr-4"></p>
      <vs-button v-if="btndis" color="success" type="filled" icon="visibility" @click="cusView">View</vs-button>
      <!-- <p class="pr-4"></p>
      <vs-button
        color="warning"
        type="filled"
        icon="create"
        @click="cusEdit"
        v-if="btndis"
        >Edit</vs-button
      > -->
      <p class="pr-4"></p>
      <vs-dropdown>
        <vs-button class="btn-drop" type="filled" icon="add" color="warning">Check Permit</vs-button>
        <vs-dropdown-menu>
          <!-- <vs-dropdown-item @click="goMoves"
            >ใบกำกับการขนย้ายสินค้า</vs-dropdown-item
          > -->
          <vs-dropdown-item @click="getNewPermit">New Permit</vs-dropdown-item>
          <vs-dropdown-item @click="regetPermit">Reget Permit</vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
      <p class="pr-4"></p>
      <vs-button color="danger" type="filled" icon="remove_circle_outline" @click="cusDel"
        v-if="btndis3">ของไม่ตรงสั่งปล่อย</vs-button>
      <p class="pr-4"></p>
      <vs-button color="success" type="filled" icon="list" @click="goDetail" v-if="btndis2">Permit Details</vs-button>
      <p class="pr-4"></p>
      <vs-button type="filled" icon="add" color="warning" v-if="btndis" @click="goShipping">Shipping</vs-button>
      <p class="pr-4"></p>
      <vs-dropdown>
        <vs-button v-if="btndis2" class="btn-drop" type="filled" icon="print" color="danger">Permit Document</vs-button>
        <vs-dropdown-menu>
          <!-- <vs-dropdown-item @click="goMoves"
            >ใบกำกับการขนย้ายสินค้า</vs-dropdown-item
          > -->
          <vs-dropdown-item @click="goPreview">Preview</vs-dropdown-item>
          <vs-dropdown-item @click="goReprint" v-if="allowReprint == 'Y'">RePrint</vs-dropdown-item>
          <vs-dropdown-item @click="goPermits" v-if="allowPrint == 'Y'">Print</vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
      <p class="pr-4"></p>

      <!-- <div class="fab-wrapper" :style="fabStyle" v-if="btndis">
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="
              fab
              p-8
              rounded-full
              cursor-pointer
              flex
              items-center
              justify-between
            "
          >
            <feather-icon icon="ChevronUpIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item
              v-for="fab in fabact"
              :key="fab.act"
              @click="handle_function_call(fab.act)"
            >
              <span>{{ fab.label }}</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div> -->
    </div>

    <transition-group enter-active-class="animated lightSpeedIn" leave-active-class="animated lightSpeedOut">
      <exbupload v-if="comUpload" :key="comUpload" @done="uploadDone"></exbupload>
      <exbadd v-if="addshow" key="addshow" :acstate="acstate" :recid="recid" @grid="grid"></exbadd>
      <cpview v-if="viewshow" key="viewshow" :acstate="acstate" :exbordersNumber="exbordersNumber" @grid="grid">
      </cpview>
      <aggrid v-if="gridshow" :key="gridshow" @recsel="recsel" :companyGroupsCode="companyGroupsCode"
        @mousedown.middle.native="getXY"></aggrid>
    </transition-group>

    <vs-popup title="เลขที่ใบขนสินค้า" :active.sync="popupActive2">
      <!-- <vs-input
        class="w-full mb-6"
        placeholder="ผู้อนุมัติ"
        v-model="approval"
      />
      <vs-button
        v-if="validName"
        color="success"
        type="filled"
        icon="check"
        @click="acceptConfirm"
        >Approve</vs-button
      > -->
      <div class="columns">
        <div class="column is-narrow mt-3" style="width: 100px; text-align: right">
          <span>declarationNo</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 250px">
            <vs-input class="w-full" icon-pack="feather" icon="icon-code" icon-no-border v-model="declarationNo" />
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-narrow mt-3" style="width: 100px; text-align: right">
          <span></span>
        </div>
        <div class="column is-narrow">
          <div style="width: 250px">
            <vs-button v-if="validName" color="success" type="filled" icon="check" @click="acceptregetPermit">Get
              Data</vs-button>
          </div>
        </div>
      </div>
    </vs-popup>

    <vs-popup title="Shipping Name" :active.sync="popupActive4">
      <div class="columns">
        <div class="column is-narrow mt-3" style="width: 100px; text-align: right">
          <span>ชื่อ</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 350px">
            <vs-select autocomplete v-model="shipname" class="w-full">
              <vs-select-item v-for="ltype in ships" :key="ltype.code" :value="ltype.code" :text="ltype.tname" />
            </vs-select>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-narrow mt-3" style="width: 100px; text-align: right">
          <span></span>
        </div>
        <div class="column is-narrow">
          <div style="width: 250px">
            <vs-button color="success" type="filled" icon="check" @click="acceptConfirm4">Submit</vs-button>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
// import aggrid from "./DataTable/AgGrid";
import aggrid from "./grid";
import exbadd from "./cpadd.vue";
import cpview from "./cpview.vue";
import exbupload from "./exbupload";
// import CustomNotify from "./CustomNotify.vue"

import pdfMake from "pdfmake";
import pdfFonts from "../../../assets/custom-fonts";
import axios from "axios";
import {
  BASE_API_URL,
  PROX_URL,
  NETBAY_URL,
  NETBAY_User,
  NETBAY_Password,
  NETBAY_Companycode,
  CUSTOMS_ENV,
  ENV_CHECK,
  CUSTOMS_AUTH,
  CUSTOMS_User,
  CUSTOMS_Password,
  CUSTOMS_GRANT_TYPE,
  CUSTOMS_CLIENT_ID,
  CUSTOMS_CLIENT_SECRET,
  CUSTOMS_CLIENT_SCOPE,
} from "@/constants/index.ts";
import JsBarcode from "jsbarcode/bin/JsBarcode";

export default {
  data() {
    return {
      shipname: "",
      ships: [],
      allowReprint: "N",
      allowPrint: "N",
      popupActive2: false,
      declarationNo: "",
      exbordersNumber: "",
      daday: "",
      damonth: "",
      dayear: "",
      dtoday: "",
      documentType: "",
      businessPartnersCode: "",
      userid: "",
      companyGroupsCode: "",
      arData: [],
      contents: [],
      viewshow: false,
      addshow: false,
      gridshow: false,
      btndis: false,
      btndis2: false,
      btndis3: false,
      comUpload: false,
      popupActive4: false,
      recid: "0",
      curX: null,
      curY: null,
      acstate: null,
      fabact: [
        { act: "cusAdd", label: "Add" },
        { act: "cusEdit", label: "Edit" },
        { act: "cusDel", label: "Delete" },
        { act: "goDetail", label: "Exbdetails" },
        { act: "hideFab", label: "Hide" },
      ],
    };
  },
  computed: {
    validName() {
      return this.declarationNo.length > 13;
    },
    fabStyle: function () {
      return {
        left: this.curX + "px",
        top: this.curY + "px",
      };
    },
  },
  methods: {
    goShipping() {
      this.shipname = "";
      this.popupActive4 = true;
    },
    async acceptConfirm4() {
      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        this.readonly = true;
        this.popupActive4 = false;

        if (token) {
          const formDataf = {
            number: this.exbordersNumber,
            shipname: this.shipname,
            editor: String(this.userid),
            companyGroupsCode: this.companyGroupsCode,
          };

          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/exbdetails/addShippingDto`,
            formDataf,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data.message,
            });

            this.errdata = response.data.errdata;
            this.errorshow = true;
          } else {
            if (this.$store.state.reportgrid == 0) {
              this.$store.dispatch("setReportGrid", 1);
            } else {
              this.$store.dispatch("setReportGrid", 0);
            }

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "๊Update Complete",
              text: response.data.message,
            });
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }
    },
    textToBase64Barcode(text) {
      var canvas = document.createElement("canvas");
      JsBarcode(canvas, text, { format: "CODE39", displayValue: false });
      return canvas.toDataURL("image/png");
    },
    cvDate(date) {
      let d = new Date(date);
      let dformat =
        [d.getDate(), d.getMonth() + 1, d.getFullYear()].join("/") +
        " " +
        [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
      return dformat;
    },
    cvTimeNoDate(date) {
      let d = new Date(date);
      let dformat = [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
      return dformat;
    },
    cvDateNoTime(date) {
      let d = new Date(date);
      let dformat = [d.getDate(), d.getMonth() + 1, d.getFullYear()].join("/");
      return dformat;
    },
    handle_function_call(function_name) {
      this[function_name]();
    },
    uploadDone() {
      // alert("Done");
      this.comUpload = false;

      this.gridshow = true;
    },
    upload() {
      this.comUpload = true;
      this.addshow = false;
      this.gridshow = false;
      this.btndis = false;
    },
    recsel(val, val2, val3, val4) {
      // console.log(val);
      // console.log(val2);
      // console.log(val2==null);
      // console.log(val3);
      this.exbordersNumber = val4;

      this.btndis2 = true;
      if (val2 == "WAIT") {
        this.btndis = true;
      } else {
        this.btndis = false;
      }
      this.recid = val;
      this.documentType = val3;

      if (val3 == "1") {
        this.btndis3 = true;
      } else {
        this.btndis3 = false;
      }

      if (val2 == null) {
        this.allowReprint = "N";
      } else {
        this.allowReprint = "Y";
      }
    },
    goDetail() {
      localStorage.setItem("LS_Page", this.$route.path);
      this.btndis = true;
      this.$router.replace("/customspermitdetails/" + this.recid);
    },
    conCMAN() {
      // console.log(this.recid);
      // this.$router.replace("/CMAN" );
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Do you want to Convert? " + this.recid,
        accept: this.acceptCMAN,
      });
    },
    acceptCMAN() {
      this.btndis = false;
      const formData = {
        token: localStorage.getItem("token"),
        dbname: localStorage.getItem("dbname"),
        number: this.recid,
      };
      axios
        .post("/ApiConvertToCmans", formData)
        .then((response) => {
          if (response.data.status == "error") {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Convert Error",
              text: response.data.message,
            });
          } else {
            this.$store.dispatch("setReportGrid", 1);

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Convert Complete",
              text: response.data.message,
            });
            this.$router.replace("/CMAN");
          }
        })
        .catch((err) => {
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Deleted Error",
            text: err,
          });
        });

      // this.gridshow = false;
      // this.gridshow = true;
    },
    cusAdd() {
      // console.log('cusAdd')
      this.comUpload = false;
      this.recid = 0;
      this.addshow = true;
      this.gridshow = false;
      this.viewshow = false;
      this.btndis = false;
      this.acstate = "ADD";
    },
    grid() {
      // console.log(this.$store.state.reportgrid)
      this.viewshow = false;
      this.comUpload = false;
      this.addshow = false;
      this.gridshow = false;
      this.btndis = false;
      setTimeout(() => {
        this.gridshow = true;
      }, 300);
      // this.$store.dispatch("setReportGrid", 0);
    },
    cusView() {
      this.btndis = true;
      this.viewshow = true;
      this.addshow = false;
      this.gridshow = false;
      this.btndis = false;
      this.errorshow = false;
      this.acstate = "EDIT";
    },
    cusEdit() {
      this.viewshow = false;
      this.comUpload = false;
      this.addshow = true;
      this.gridshow = false;
      this.btndis = false;
      this.acstate = "EDIT";
    },
    getNewPermit() {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: `Confirm`,
        text: "Do you want to Get New Permit? ",
        accept: this.acceptgetNewPermit,
      });
    },
    async acceptgetNewPermit() {
      // console.log(this.$store.state.reportgrid)

      try {
        this.allowPrint = "Y";

        setTimeout(() => {
          this.allowPrint = "N";
        }, 10000);

        if (CUSTOMS_ENV == "PROD") {
          this.getListOfCustomsPermit();
        } else {
          this.getListOfCustomsPermitFake();
        }

        // this.fdmsLogin();
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }

      // this.gridshow = false;
      // this.gridshow = true;
    },
    regetPermit() {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: `Confirm`,
        text: "Do you want to Reget Permit? ",
        accept: this.goApprove,
      });
    },
    goApprove() {
      this.declarationNo = "";
      this.popupActive2 = true;
    },
    async acceptregetPermit() {
      // console.log(this.$store.state.reportgrid)
      this.popupActive2 = false;

      try {
        if (CUSTOMS_ENV == "PROD") {
          this.getCustomsPermit();
        } else {
          this.getCustomsPermitFake();
        }

        this.allowPrint = "Y";

        setTimeout(() => {
          this.allowPrint = "N";
        }, 10000);
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }

      // this.gridshow = false;
      // this.gridshow = true;
    },
    // async getCustomsPermit() {
    //   //  console.log(CUSTOMS_TOKEN);
    //   try {
    //     const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

    //     const CUSTOMS_TOKEN = localStorage.getItem("CUSTOMS_TOKEN");

    //     if (CUSTOMS_TOKEN) {
    //       const formData = {
    //         declarationNo: this.declarationNo,
    //         releasePort: 1197,
    //         userName: CUSTOMS_User,
    //         password: CUSTOMS_Password,
    //       };

    //       const response = await axios.post(
    //         `${CUSTOMS_URL}getCustomsPermit`,
    //         formData,
    //         {
    //           headers: { Authorization: "Bearer " + CUSTOMS_TOKEN },
    //         }
    //       );
    //       // console.log(response.data.declarationNo);
    //       // console.log(response.data.declarationNo == "No Data Found");

    //       if (response.data.declarationNo == "No data Found") {
    //         this.loading = false;
    //         this.$vs.notify({
    //           position: "top-right",
    //           color: "danger",
    //           title: "Response from CUSTOMS",
    //           text: "No Data Found",
    //         });
    //       } else if (response.data.httpMessage) {
    //         this.loading = false;
    //         this.$vs.notify({
    //           position: "top-right",
    //           color: "danger",
    //           title: "Error from CUSTOMS",
    //           text: response.data.httpMessage,
    //         });
    //       } else {
    //         const formData2 = {
    //           permits: response.data,
    //         };

    //         const response2 = await axios.post(
    //           `${BASE_API_URL}/outbound-svc/customspermit/updatereGetPermits`,
    //           formData2,
    //           {
    //             headers: { Authorization: "Bearer " + token.accessToken },
    //           }
    //         );

    //         if (response2.data.status != "success") {
    //           this.loading = false;
    //           this.$vs.notify({
    //             position: "top-right",
    //             color: "danger",
    //             title: "Error from Backend",
    //             text: response2.data,
    //           });
    //         } else {
    //           this.gridshow = false;
    //           setTimeout(() => {
    //             this.gridshow = true;
    //           }, 300);

    //           this.$vs.notify({
    //             position: "top-right",
    //             color: "success",
    //             title: "Success",
    //             text: "Update New Record Complete",
    //           });
    //         }
    //       }
    //     }
    //   } catch (error) {
    //     alert(error.message);
    //   }
    // },
    async getCustomsPermit() {
      //  console.log(CUSTOMS_TOKEN);
      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

        const formData = {
          declarationNo: this.declarationNo,
          editor: String(this.userid),
        };

        const response = await axios.post(
          `${BASE_API_URL}/queue-svc/jqueue/getCustomsPermit`,
          formData,
          {
            headers: { Authorization: "Bearer " + token.accessToken },
          }
        );
        // console.log(response.data.declarationNo);
        // console.log(response.data.declarationNo == "No Data Found");

        if (response.data.status == "error") {
          this.loading = false;
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Response from CUSTOMS",
            text: response.data.message,
          });
        } else {
          const formData2 = {
            permits: response.data.message,
          };

          const response2 = await axios.post(
            `${BASE_API_URL}/outbound-svc/customspermit/updatereGetPermits`,
            formData2,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          if (response2.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response2.data,
            });
          } else {
            this.gridshow = false;
            setTimeout(() => {
              this.gridshow = true;
            }, 300);

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Success",
              text: "Update New Record Complete",
            });
          }
        }

      } catch (error) {
        alert(error.message);
      }
    },
    async getCustomsPermitFake() {
      //  console.log(CUSTOMS_TOKEN);
      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

        if (token) {
          const formData = {
            declarationNo: this.declarationNo,
            editor: String(this.userid),
          };

          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/customspermit/getCustomsPermitFake`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );
          // console.log(response.data);

          if (response.data.declarationNo == "No Data Found") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Response from Backend",
              text: "No Data Found",
            });
          } else {
            const formData2 = {
              permits: response.data,
            };

            const response2 = await axios.post(
              `${BASE_API_URL}/outbound-svc/customspermit/updatereGetPermitsFake`,
              formData2,
              {
                headers: { Authorization: "Bearer " + token.accessToken },
              }
            );

            if (response2.data.status != "success") {
              this.loading = false;
              this.$vs.notify({
                position: "top-right",
                color: "danger",
                title: "Error from Backend",
                text: response2.data,
              });
            } else {
              this.gridshow = false;
              setTimeout(() => {
                this.gridshow = true;
              }, 300);

              this.$vs.notify({
                position: "top-right",
                color: "success",
                title: "Success",
                text: "Update Reget Petmit Complete",
              });
            }
          }
        }
      } catch (error) {
        alert(error.message);
      }
    },
    // async getListOfCustomsPermit() {
    //   //  console.log(CUSTOMS_TOKEN);
    //   try {
    //     const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

    //     const CUSTOMS_TOKEN = localStorage.getItem("CUSTOMS_TOKEN");

    //     if (CUSTOMS_TOKEN) {
    //       const formData = {
    //         releasePort: 1197,
    //         userName: CUSTOMS_User,
    //         password: CUSTOMS_Password,
    //       };

    //       const response = await axios.post(
    //         `${CUSTOMS_URL}getListOfCustomsPermit`,
    //         formData,
    //         {
    //           headers: { Authorization: "Bearer " + CUSTOMS_TOKEN },
    //         }
    //       );
    //       // console.log(response.data);

    //       if (response.data[0].houseBL == "No Data Found") {
    //         this.loading = false;
    //         this.$vs.notify({
    //           position: "top-right",
    //           color: "danger",
    //           title: "Response from CUSTOMS",
    //           text: "No Data Found",
    //         });
    //       } else if (response.data[0].httpMessage) {
    //         this.loading = false;
    //         this.$vs.notify({
    //           position: "top-right",
    //           color: "danger",
    //           title: "Error from CUSTOMS",
    //           text: response.data[0].httpMessage,
    //         });
    //       } else {
    //         const formData2 = {
    //           permits: response.data,
    //         };

    //         const response2 = await axios.post(
    //           `${BASE_API_URL}/outbound-svc/customspermit/updateNewPermits`,
    //           formData2,
    //           {
    //             headers: { Authorization: "Bearer " + token.accessToken },
    //           }
    //         );

    //         if (response2.data.status != "success") {
    //           this.loading = false;
    //           this.$vs.notify({
    //             position: "top-right",
    //             color: "danger",
    //             title: "Error from Backend",
    //             text: response2.data,
    //           });
    //         } else {
    //           this.gridshow = false;
    //           setTimeout(() => {
    //             this.gridshow = true;
    //           }, 300);

    //           this.$vs.notify({
    //             position: "top-right",
    //             color: "success",
    //             title: "Success",
    //             text: "Update New Record Complete",
    //           });
    //         }
    //       }
    //     }
    //   } catch (error) {
    //     alert(error.message);
    //   }
    // },
    async getListOfCustomsPermit() {
      //  console.log(CUSTOMS_TOKEN);
      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

        const formData = {
          editor: String(this.userid),
        };

        const response = await axios.post(
          `${BASE_API_URL}/queue-svc/jqueue/getListOfCustomsPermit`,
          formData,
          {
            headers: { Authorization: "Bearer " + token.accessToken },
          }
        );

        if (response.data.status == "error") {
          this.loading = false;
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Response from CUSTOMS",
            text: response.data.message,
          });
        } else {
          const formData2 = {
            permits: response.data.message,
          };

          const response2 = await axios.post(
            `${BASE_API_URL}/outbound-svc/customspermit/updateNewPermits`,
            formData2,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          if (response2.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response2.data,
            });
          } else {
            this.gridshow = false;
            setTimeout(() => {
              this.gridshow = true;
            }, 300);

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Success",
              text: "Update New Record Complete",
            });
          }
        }

      } catch (error) {
        alert(error.message);
      }
    },
    async getListOfCustomsPermitFake() {
      //  console.log(CUSTOMS_TOKEN);
      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

        if (token) {
          const formData = {
            editor: String(this.userid),
          };

          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/customspermit/getListOfCustomsPermitFake`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );
          // console.log(response.data);

          if (response.data[0].houseBL == "No Data Found") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Response from Backend",
              text: "No Data Found",
            });
          } else if (response.data[0].httpMessage) {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data[0].httpMessage,
            });
          } else {
            const formData2 = {
              permits: response.data,
            };

            const response2 = await axios.post(
              `${BASE_API_URL}/outbound-svc/customspermit/updateNewPermitsFake`,
              formData2,
              {
                headers: { Authorization: "Bearer " + token.accessToken },
              }
            );

            if (response2.data.status != "success") {
              this.loading = false;
              this.$vs.notify({
                position: "top-right",
                color: "danger",
                title: "Error from Backend",
                text: response2.data,
              });
            } else {
              this.gridshow = false;
              setTimeout(() => {
                this.gridshow = true;
              }, 300);

              this.$vs.notify({
                position: "top-right",
                color: "success",
                title: "Success",
                text: "Update New Record Complete",
              });
            }
          }
        }
      } catch (error) {
        alert(error.message);
      }
    },
    // async sendInspection() {
    //   //  console.log(CUSTOMS_TOKEN);
    //   try {
    //     const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

    //     if (token) {
    //       const formData = {
    //         number: this.recid,
    //         editor: String(this.userid),
    //       };

    //       const response = await axios.post(
    //         `${BASE_API_URL}/outbound-svc/customspermit/getPermitForResponse`,
    //         formData,
    //         {
    //           headers: { Authorization: "Bearer " + token.accessToken },
    //         }
    //       );
    //       // console.log(response.data);

    //       if (response.data.status != "success") {
    //         this.loading = false;
    //         this.$vs.notify({
    //           position: "top-right",
    //           color: "danger",
    //           title: "Response from Backend",
    //           text: "No Data Found",
    //         });
    //       } else {
    //         const CUSTOMS_TOKEN = localStorage.getItem("CUSTOMS_TOKEN");

    //         const formData2 = {
    //           userName: CUSTOMS_User,
    //           password: CUSTOMS_Password,
    //           releasePort: 1197,
    //           customsPermit: response.data.message,
    //         };

    //         const response2 = await axios.post(
    //           `${CUSTOMS_URL}customsPermitResponse`,
    //           formData2,
    //           {
    //             headers: { Authorization: "Bearer " + CUSTOMS_TOKEN },
    //           }
    //         );

    //         if (response2.data != "OK") {
    //           this.loading = false;
    //           this.$vs.notify({
    //             position: "top-right",
    //             color: "danger",
    //             title: "Error from Backend",
    //             text: response2.data,
    //           });

    //           const moment = require("moment-timezone");
    //           const timezone = "Asia/Bangkok";
    //           const now = moment().tz(timezone);

    //           const formData3 = {
    //             customsPermit: response.data.message,
    //             resstate: response2.data,
    //             createdAt: now,
    //           };

    //           await axios.post(
    //             `${BASE_API_URL}/outbound-svc/customspermit/resCust`,
    //             formData3,
    //             {
    //               headers: { Authorization: "Bearer " + token.accessToken },
    //             }
    //           );
    //         } else {
    //           const moment = require("moment-timezone");
    //           const timezone = "Asia/Bangkok";
    //           const now = moment().tz(timezone);

    //           const formData3 = {
    //             customsPermit: response.data.message,
    //             resstate: response2.data,
    //             createdAt: now,
    //           };

    //           await axios.post(
    //             `${BASE_API_URL}/outbound-svc/customspermit/resCust`,
    //             formData3,
    //             {
    //               headers: { Authorization: "Bearer " + token.accessToken },
    //             }
    //           );

    //           this.gridshow = false;
    //           setTimeout(() => {
    //             this.gridshow = true;
    //           }, 300);

    //           this.$vs.notify({
    //             position: "top-right",
    //             color: "success",
    //             title: "Success",
    //             text: "ส่งข้อมูล Pertmit Complete",
    //           });
    //         }
    //       }
    //     }
    //   } catch (error) {
    //     alert(error.message);
    //   }
    // },
    async sendInspection() {
      //  console.log(CUSTOMS_TOKEN);
      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

        if (token) {
          const formData = {
            number: this.recid,
            editor: String(this.userid),
          };

          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/customspermit/getPermitForResponse`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );
          // console.log(response.data);

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Response from Backend",
              text: "No Data Found",
            });
          } else {

            const formData2 = {
              editor: String(this.userid),
              customsPermit: response.data.message,
            };

            const response2 = await axios.post(
              `${BASE_API_URL}/queue-svc/jqueue/sendPermitWith2or6`,
              formData2,
              {
                headers: { Authorization: "Bearer " + token.accessToken },
              }
            );

            if (response2.data != "OK") {
              this.loading = false;
              this.$vs.notify({
                position: "top-right",
                color: "danger",
                title: "Error from Backend",
                text: response2.data.message,
              });

              const moment = require("moment-timezone");
              const timezone = "Asia/Bangkok";
              const now = moment().tz(timezone);

              const formData3 = {
                customsPermit: response.data.message,
                resstate: response2.data.message,
                createdAt: now,
              };

              await axios.post(
                `${BASE_API_URL}/outbound-svc/customspermit/resCust`,
                formData3,
                {
                  headers: { Authorization: "Bearer " + token.accessToken },
                }
              );
            } else {
              const moment = require("moment-timezone");
              const timezone = "Asia/Bangkok";
              const now = moment().tz(timezone);

              const formData3 = {
                customsPermit: response.data.message,
                resstate: response2.data.message,
                createdAt: now,
              };

              await axios.post(
                `${BASE_API_URL}/outbound-svc/customspermit/resCust`,
                formData3,
                {
                  headers: { Authorization: "Bearer " + token.accessToken },
                }
              );

              this.gridshow = false;
              setTimeout(() => {
                this.gridshow = true;
              }, 300);

              this.$vs.notify({
                position: "top-right",
                color: "success",
                title: "Success",
                text: "ส่งข้อมูล Pertmit Complete",
              });
            }
          }
        }
      } catch (error) {
        alert(error.message);
      }
    },
    async sendInspectionFake() {
      //  console.log(CUSTOMS_TOKEN);
      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

        if (token) {
          const formData = {
            number: this.recid,
            editor: String(this.userid),
          };

          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/customspermit/getPermitForResponse`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );
          // console.log(response.data);

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Response from Backend",
              text: "No Data Found",
            });
          } else {
            const formData2 = {
              userName: CUSTOMS_User,
              password: CUSTOMS_Password,
              releasePort: 1197,
              customsPermit: response.data.message,
            };

            const response2 = await axios.post(
              `${BASE_API_URL}/outbound-svc/customspermit/customsPermitResponseFake`,
              formData2,
              {
                headers: { Authorization: "Bearer " + token.accessToken },
              }
            );

            if (response2.data != "OK") {
              this.loading = false;
              this.$vs.notify({
                position: "top-right",
                color: "danger",
                title: "Error from Backend",
                text: response2.data,
              });

              const moment = require("moment-timezone");
              const timezone = "Asia/Bangkok";
              const now = moment().tz(timezone);

              const formData3 = {
                customsPermit: response.data.message,
                resstate: response2.data,
                createdAt: now,
              };

              await axios.post(
                `${BASE_API_URL}/outbound-svc/customspermit/resCust`,
                formData3,
                {
                  headers: { Authorization: "Bearer " + token.accessToken },
                }
              );
            } else {
              const moment = require("moment-timezone");
              const timezone = "Asia/Bangkok";
              const now = moment().tz(timezone);

              const formData3 = {
                customsPermit: response.data.message,
                resstate: response2.data,
                createdAt: now,
              };

              await axios.post(
                `${BASE_API_URL}/outbound-svc/customspermit/resCust`,
                formData3,
                {
                  headers: { Authorization: "Bearer " + token.accessToken },
                }
              );

              this.gridshow = false;
              setTimeout(() => {
                this.gridshow = true;
              }, 300);

              this.$vs.notify({
                position: "top-right",
                color: "success",
                title: "Success",
                text: "ส่งข้อมูล Pertmit Complete",
              });
            }
          }
        }
      } catch (error) {
        alert(error.message);
      }
    },
    // async sendPermit6() {
    //   //  console.log(CUSTOMS_TOKEN);
    //   try {
    //     this.acstate = "ADD";

    //     const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

    //     if (token) {
    //       const formData = {
    //         number: this.recid,
    //         editor: String(this.userid),
    //       };

    //       const response = await axios.post(
    //         `${BASE_API_URL}/outbound-svc/customspermit/getPermitForResponse`,
    //         formData,
    //         {
    //           headers: { Authorization: "Bearer " + token.accessToken },
    //         }
    //       );
    //       // console.log(response.data);

    //       if (response.data.status != "success") {
    //         this.loading = false;
    //         this.$vs.notify({
    //           position: "top-right",
    //           color: "danger",
    //           title: "Response from Backend",
    //           text: response.data.message,
    //         });
    //       } else {
    //         const CUSTOMS_TOKEN = localStorage.getItem("CUSTOMS_TOKEN");

    //         const formData2 = {
    //           userName: CUSTOMS_User,
    //           password: CUSTOMS_Password,
    //           releasePort: 1197,
    //           customsPermit: response.data.message,
    //         };

    //         const response2 = await axios.post(
    //           `${CUSTOMS_URL}customsPermitResponse`,
    //           formData2,
    //           {
    //             headers: { Authorization: "Bearer " + CUSTOMS_TOKEN },
    //           }
    //         );

    //         // if (response2.data != "OK") {
    //         //   this.loading = false;
    //         //   this.$vs.notify({
    //         //     position: "top-right",
    //         //     color: "danger",
    //         //     title: "Error from Backend",
    //         //     text: response2.data,
    //         //   });

    //         //   const moment = require("moment-timezone");
    //         //   const timezone = "Asia/Bangkok";
    //         //   const now = moment().tz(timezone);

    //         //   const formData3 = {
    //         //     customsPermit: response.data.message,
    //         //     resstate: response2.data,
    //         //     createdAt: now,
    //         //   };

    //         //   await axios.post(
    //         //     `${BASE_API_URL}/outbound-svc/customspermit/resCust`,
    //         //     formData3,
    //         //     {
    //         //       headers: { Authorization: "Bearer " + token.accessToken },
    //         //     }
    //         //   );
    //         // } else {
    //         const moment = require("moment-timezone");
    //         const timezone = "Asia/Bangkok";
    //         const now = moment().tz(timezone);

    //         const formData3 = {
    //           customsPermit: response.data.message,
    //           resstate: response2.data,
    //           createdAt: now,
    //         };

    //         await axios.post(
    //           `${BASE_API_URL}/outbound-svc/customspermit/resCust`,
    //           formData3,
    //           {
    //             headers: { Authorization: "Bearer " + token.accessToken },
    //           }
    //         );

    //         const formData4 = {
    //           number: this.recid,
    //           editor: String(this.userid),
    //         };

    //         const response4 = await axios.post(
    //           `${BASE_API_URL}/outbound-svc/customspermit/getCreateToDom`,
    //           formData4,
    //           {
    //             headers: { Authorization: "Bearer " + token.accessToken },
    //           }
    //         );

    //         if (response4.data.status != "success") {
    //           this.loading = false;
    //           this.$vs.notify({
    //             position: "top-right",
    //             color: "danger",
    //             title: "Error from Backend",
    //             text: response4.data.message,
    //           });
    //         } else {
    //           // console.log(response4.data);

    //           const formData5 = {
    //             companyGroupsCode: response4.data.message.companyGroupsCode,
    //             dcldate: response4.data.message.dcldate,
    //             transModesId: response4.data.message.transModesId,
    //             vesselname: response4.data.message.vesselname,
    //             pol: response4.data.message.pol,
    //             pod: response4.data.message.pod,
    //             acstate: this.acstate,
    //             businessPartnersCode:
    //               response4.data.message.businessPartnersCode,
    //             invnum: response4.data.message.invnum,
    //             itemnum: response4.data.message.itemnum,
    //             inbordersNumber: response4.data.message.inbordersNumber,
    //             inbitemnum: response4.data.message.inbitemnum,
    //             itemqty: response4.data.message.itemqty,
    //             remark: response4.data.message.remark,
    //             inbdetailsSkuscode: response4.data.message.inbdetailsSkuscode,
    //             mawb: response4.data.message.mawb,
    //             hawb: response4.data.message.hawb,
    //             dclnumber: response4.data.message.dclnumber,
    //             repdate: response4.data.message.repdate,
    //             shname: response4.data.message.shname,
    //             shnamea: response4.data.message.shnamea,
    //             cnname: response4.data.message.cnname,
    //             editor: String(this.userid),
    //             connumber: response4.data.message.connumber,
    //             itempck: response4.data.message.itempck,
    //             itemnw: response4.data.message.itemnw,
    //             cnstreet: response4.data.message.cnstreet,
    //             cndist: response4.data.message.cndist,
    //             cnsubp: response4.data.message.cnsubp,
    //             cnprov: response4.data.message.cnprov,
    //             cnnamea: response4.data.message.cnnamea,
    //           };

    //           // console.log(formData);

    //           const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

    //           if (token) {
    //             try {
    //               const response5 = await axios.post(
    //                 `${BASE_API_URL}/outbound-svc/cpermits/create`,
    //                 formData5,
    //                 {
    //                   headers: {
    //                     Authorization: "Bearer " + token.accessToken,
    //                   },
    //                 }
    //               );

    //               if (response5.data.status != "success") {
    //                 this.$vs.notify({
    //                   position: "top-right",
    //                   color: "danger",
    //                   title: "Error",
    //                   text: response5.data.message,
    //                 });
    //               } else {
    //                 if (ENV_CHECK == "PROD") {
    //                   this.submitFDMS(response5.data.ReferenceNumber);
    //                 }

    //                 this.$vs.notify({
    //                   position: "top-right",
    //                   color: "success",
    //                   title: "Success",
    //                   text: "สร้างรายการ To Dom สำเร็จ",
    //                 });
    //               }
    //             } catch (error) {
    //               // return error;
    //               alert("กรุณาเข้าระบบอีกครั้ง");
    //               // await this.$router.replace("/pages/login/");
    //             }
    //           }
    //         }

    //         this.gridshow = false;
    //         setTimeout(() => {
    //           this.gridshow = true;
    //         }, 500);

    //         this.$vs.notify({
    //           position: "top-right",
    //           color: "success",
    //           title: "Success",
    //           text: "ส่งข้อมูล Pertmit Complete",
    //         });
    //         // }
    //       }
    //     }
    //   } catch (error) {
    //     alert(error.message);
    //   }
    // },
    // async sendPermit6() {
    //   //  console.log(CUSTOMS_TOKEN);
    //   try {
    //     this.acstate = "ADD";

    //     const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

    //     if (token) {
    //       const formData = {
    //         number: this.recid,
    //         editor: String(this.userid),
    //       };

    //       const response = await axios.post(
    //         `${BASE_API_URL}/outbound-svc/customspermit/getPermitForResponse`,
    //         formData,
    //         {
    //           headers: { Authorization: "Bearer " + token.accessToken },
    //         }
    //       );
    //       // console.log(response.data);

    //       if (response.data.status != "success") {
    //         this.loading = false;
    //         this.$vs.notify({
    //           position: "top-right",
    //           color: "danger",
    //           title: "Response from Backend",
    //           text: response.data.message,
    //         });
    //       } else {
    //         const CUSTOMS_TOKEN = localStorage.getItem("CUSTOMS_TOKEN");

    //         const formData2 = {
    //           userName: CUSTOMS_User,
    //           password: CUSTOMS_Password,
    //           releasePort: 1197,
    //           customsPermit: response.data.message,
    //         };

    //         const response2 = await axios.post(
    //           `${CUSTOMS_URL}customsPermitResponse`,
    //           formData2,
    //           {
    //             headers: { Authorization: "Bearer " + CUSTOMS_TOKEN },
    //           }
    //         );

    //         const moment = require("moment-timezone");
    //         const timezone = "Asia/Bangkok";
    //         const now = moment().tz(timezone);

    //         const formData3 = {
    //           customsPermit: response.data.message,
    //           resstate: response2.data,
    //           createdAt: now,
    //         };

    //         await axios.post(
    //           `${BASE_API_URL}/outbound-svc/customspermit/resCust`,
    //           formData3,
    //           {
    //             headers: { Authorization: "Bearer " + token.accessToken },
    //           }
    //         );

    //         const formData4 = {
    //           number: this.recid,
    //           editor: String(this.userid),
    //         };

    //         const response4 = await axios.post(
    //           `${BASE_API_URL}/outbound-svc/customspermit/getCreateToDomNew`,
    //           formData4,
    //           {
    //             headers: { Authorization: "Bearer " + token.accessToken },
    //           }
    //         );

    //         if (response4.data.status != "success") {
    //           this.loading = false;
    //           this.$vs.notify({
    //             position: "top-right",
    //             color: "danger",
    //             title: "Error from Backend",
    //             text: response4.data.message,
    //           });
    //         } else {
    //           // console.log(response4.data);
    //           this.$vs.notify({
    //             position: "top-right",
    //             color: "success",
    //             title: "Success",
    //             text: "สร้างรายการ To Dom สำเร็จ",
    //           });
    //         }

    //         this.gridshow = false;

    //         setTimeout(() => {
    //           this.gridshow = true;
    //         }, 1000);

    //         this.$vs.notify({
    //           position: "top-right",
    //           color: "success",
    //           title: "Success",
    //           text: "ส่งข้อมูล Pertmit Complete",
    //         });
    //         // }
    //       }
    //     }
    //   } catch (error) {
    //     alert(error.message);
    //   }
    // },
    async sendPermit6() {
      //  console.log(CUSTOMS_TOKEN);
      try {
        this.acstate = "ADD";

        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

        if (token) {
          const formData = {
            number: this.recid,
            editor: String(this.userid),
          };

          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/customspermit/getPermitForResponse`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );
          // console.log(response.data);

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Response from Backend",
              text: response.data.message,
              time:8000,
            });
          } else {

            const formData2 = {
              editor: String(this.userid),
              customsPermit: response.data.message,
            };

            const response2 = await axios.post(
              `${BASE_API_URL}/queue-svc/jqueue/sendPermitWith2or6`,
              formData2,
              {
                headers: { Authorization: "Bearer " + token.accessToken },
              }
            );

            const moment = require("moment-timezone");
            const timezone = "Asia/Bangkok";
            const now = moment().tz(timezone);

            const formData3 = {
              customsPermit: response.data.message,
              resstate: response2.data.message,
              createdAt: now,
            };

            await axios.post(
              `${BASE_API_URL}/outbound-svc/customspermit/resCust`,
              formData3,
              {
                headers: { Authorization: "Bearer " + token.accessToken },
              }
            );

            const formData4 = {
              number: this.recid,
              editor: String(this.userid),
            };

            const response4 = await axios.post(
              `${BASE_API_URL}/outbound-svc/customspermit/getCreateToDomNew`,
              formData4,
              {
                headers: { Authorization: "Bearer " + token.accessToken },
              }
            );

            if (response4.data.status != "success") {
              this.loading = false;
              this.$vs.notify({
                position: "top-right",
                color: "danger",
                title: "Error from Backend",
                text: response4.data.message,
              });
            } else {
              // console.log(response4.data);
              this.$vs.notify({
                position: "top-right",
                color: "success",
                title: "Success",
                text: "สร้างรายการ To Dom สำเร็จ",
              });
            }

            this.gridshow = false;

            setTimeout(() => {
              this.gridshow = true;
            }, 1000);

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Success",
              text: "ส่งข้อมูล Pertmit Complete",
            });
            // }
          }
        }
      } catch (error) {
        alert(error.message);
      }
    },
    async sendPermitFake6() {
      //  console.log(CUSTOMS_TOKEN);
      try {
        this.acstate = "ADD";

        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

        if (token) {
          const formData = {
            number: this.recid,
            editor: String(this.userid),
          };

          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/customspermit/getPermitForResponse`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );
          // console.log(response.data);

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Response from Backend",
              text: response.data.message,
            });
          } else {
            const formData2 = {
              userName: CUSTOMS_User,
              password: CUSTOMS_Password,
              releasePort: 1197,
              customsPermit: response.data.message,
            };

            const response2 = await axios.post(
              `${BASE_API_URL}/outbound-svc/customspermit/customsPermitResponseFake`,
              formData2,
              {
                headers: { Authorization: "Bearer " + token.accessToken },
              }
            );

            if (response2.data != "OK") {
              this.loading = false;
              this.$vs.notify({
                position: "top-right",
                color: "danger",
                title: "Error from Backend",
                text: response2.data,
              });

              const moment = require("moment-timezone");
              const timezone = "Asia/Bangkok";
              const now = moment().tz(timezone);

              const formData3 = {
                customsPermit: response.data.message,
                resstate: response2.data,
                createdAt: now,
              };

              await axios.post(
                `${BASE_API_URL}/outbound-svc/customspermit/resCust`,
                formData3,
                {
                  headers: { Authorization: "Bearer " + token.accessToken },
                }
              );
            } else {
              const moment = require("moment-timezone");
              const timezone = "Asia/Bangkok";
              const now = moment().tz(timezone);

              const formData3 = {
                customsPermit: response.data.message,
                resstate: response2.data,
                createdAt: now,
              };

              await axios.post(
                `${BASE_API_URL}/outbound-svc/customspermit/resCust`,
                formData3,
                {
                  headers: { Authorization: "Bearer " + token.accessToken },
                }
              );

              const formData4 = {
                number: this.recid,
                editor: String(this.userid),
              };

              const response4 = await axios.post(
                `${BASE_API_URL}/outbound-svc/customspermit/getCreateToDom`,
                formData4,
                {
                  headers: { Authorization: "Bearer " + token.accessToken },
                }
              );

              if (response4.data.status != "success") {
                this.loading = false;
                this.$vs.notify({
                  position: "top-right",
                  color: "danger",
                  title: "Error from Backend",
                  text: response4.data.message,
                });
              } else {
                // console.log(response4.data);

                const formData5 = {
                  companyGroupsCode: response4.data.message.companyGroupsCode,
                  dcldate: response4.data.message.dcldate,
                  transModesId: response4.data.message.transModesId,
                  vesselname: response4.data.message.vesselname,
                  pol: response4.data.message.pol,
                  pod: response4.data.message.pod,
                  acstate: this.acstate,
                  businessPartnersCode:
                    response4.data.message.businessPartnersCode,
                  invnum: response4.data.message.invnum,
                  itemnum: response4.data.message.itemnum,
                  inbordersNumber: response4.data.message.inbordersNumber,
                  inbitemnum: response4.data.message.inbitemnum,
                  itemqty: response4.data.message.itemqty,
                  remark: response4.data.message.remark,
                  inbdetailsSkuscode: response4.data.message.inbdetailsSkuscode,
                  mawb: response4.data.message.mawb,
                  hawb: response4.data.message.hawb,
                  dclnumber: response4.data.message.dclnumber,
                  repdate: response4.data.message.repdate,
                  shname: response4.data.message.shname,
                  shnamea: response4.data.message.shnamea,
                  cnname: response4.data.message.cnname,
                  editor: String(this.userid),
                  connumber: response4.data.message.connumber,
                  itempck: response4.data.message.itempck,
                  itemnw: response4.data.message.itemnw,
                  cnstreet: response4.data.message.cnstreet,
                  cndist: response4.data.message.cndist,
                  cnsubp: response4.data.message.cnsubp,
                  cnprov: response4.data.message.cnprov,
                  cnnamea: response4.data.message.cnnamea,
                };

                // console.log(formData);

                const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

                if (token) {
                  try {
                    const response5 = await axios.post(
                      `${BASE_API_URL}/outbound-svc/cpermits/create`,
                      formData5,
                      {
                        headers: {
                          Authorization: "Bearer " + token.accessToken,
                        },
                      }
                    );

                    // console.log(response5.data)

                    if (response5.data.status != "success") {
                      this.$vs.notify({
                        position: "top-right",
                        color: "danger",
                        title: "Error",
                        text: response5.data.message,
                      });
                    } else {
                      if (ENV_CHECK == "PROD") {
                        this.submitFDMS(response5.data.ReferenceNumber);
                      }

                      this.$vs.notify({
                        position: "top-right",
                        color: "success",
                        title: "Success",
                        text: "สร้างรายการ To Dom สำเร็จ",
                      });
                    }
                  } catch (error) {
                    // return error;
                    alert("กรุณาเข้าระบบอีกครั้ง");
                    // await this.$router.replace("/pages/login/");
                  }
                }
              }

              this.gridshow = false;
              setTimeout(() => {
                this.gridshow = true;
              }, 500);

              this.$vs.notify({
                position: "top-right",
                color: "success",
                title: "Success",
                text: "ส่งข้อมูล Pertmit Complete",
              });
            }
          }
        }
      } catch (error) {
        alert(error.message);
      }
    },
    cusDel() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "ต้องการส่งข้อมูลตอบกลับกรมศุลกากร ของไม่ต้องสั่งปล่อย หรือไม่? ",
        accept: this.sendPermit5,
      });
    },
    async sendPermit5() {
      try {
        if (CUSTOMS_ENV == "PROD") {
          this.sendPermitWith5();
        } else {
          this.sendPermitFake5();
        }
      } catch (error) {
        // throw error;
        alert(error.message);
        // this.$router.replace("/pages/login/");
      }
    },
    // async sendPermitWith5() {
    //   //  console.log(CUSTOMS_TOKEN);
    //   try {
    //     const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

    //     if (token) {
    //       const formData = {
    //         number: this.recid,
    //         editor: String(this.userid),
    //       };

    //       const response = await axios.post(
    //         `${BASE_API_URL}/outbound-svc/customspermit/getPermitForResponse5`,
    //         formData,
    //         {
    //           headers: { Authorization: "Bearer " + token.accessToken },
    //         }
    //       );
    //       // console.log(response.data);

    //       if (response.data.status != "success") {
    //         this.loading = false;
    //         this.$vs.notify({
    //           position: "top-right",
    //           color: "danger",
    //           title: "Response from Backend",
    //           text: "No Data Found",
    //         });
    //       } else {
    //         const CUSTOMS_TOKEN = localStorage.getItem("CUSTOMS_TOKEN");

    //         const formData2 = {
    //           userName: CUSTOMS_User,
    //           password: CUSTOMS_Password,
    //           releasePort: 1197,
    //           customsPermit: response.data.message,
    //         };

    //         const response2 = await axios.post(
    //           `${CUSTOMS_URL}customsPermitResponse`,
    //           formData2,
    //           {
    //             headers: { Authorization: "Bearer " + CUSTOMS_TOKEN },
    //           }
    //         );

    //         if (response2.data != "OK") {
    //           this.loading = false;
    //           this.$vs.notify({
    //             position: "top-right",
    //             color: "danger",
    //             title: "Error from Backend",
    //             text: response2.data,
    //           });

    //           const moment = require("moment-timezone");
    //           const timezone = "Asia/Bangkok";
    //           const now = moment().tz(timezone);

    //           const formData3 = {
    //             customsPermit: response.data.message,
    //             resstate: response2.data,
    //             createdAt: now,
    //           };

    //           await axios.post(
    //             `${BASE_API_URL}/outbound-svc/customspermit/resCust`,
    //             formData3,
    //             {
    //               headers: { Authorization: "Bearer " + token.accessToken },
    //             }
    //           );
    //         } else {
    //           const moment = require("moment-timezone");
    //           const timezone = "Asia/Bangkok";
    //           const now = moment().tz(timezone);

    //           const formData3 = {
    //             customsPermit: response.data.message,
    //             resstate: response2.data,
    //             createdAt: now,
    //           };

    //           await axios.post(
    //             `${BASE_API_URL}/outbound-svc/customspermit/resCust`,
    //             formData3,
    //             {
    //               headers: { Authorization: "Bearer " + token.accessToken },
    //             }
    //           );

    //           this.gridshow = false;
    //           setTimeout(() => {
    //             this.gridshow = true;
    //           }, 300);

    //           this.$vs.notify({
    //             position: "top-right",
    //             color: "success",
    //             title: "Success",
    //             text: "ส่งข้อมูล Pertmit Complete",
    //           });
    //         }
    //       }
    //     }
    //   } catch (error) {
    //     alert(error.message);
    //   }
    // },
    async sendPermitWith5() {
      //  console.log(CUSTOMS_TOKEN);
      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

        if (token) {
          const formData = {
            number: this.recid,
            editor: String(this.userid),
          };

          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/customspermit/getPermitForResponse5`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );
          // console.log(response.data);

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Response from Backend",
              text: "No Data Found",
            });
          } else {

            const formData2 = {
              customsPermit: response.data.message,
              editor: String(this.userid),

            };

            const response2 = await axios.post(
              `${BASE_API_URL}/queue-svc/jqueue/sendPermitWith5`,
              formData2,
              {
                headers: { Authorization: "Bearer " + token.accessToken },
              }
            );

            if (response2.data != "OK") {
              this.loading = false;
              this.$vs.notify({
                position: "top-right",
                color: "danger",
                title: "Error from Customs",
                text: response2.data.message,
              });

              const moment = require("moment-timezone");
              const timezone = "Asia/Bangkok";
              const now = moment().tz(timezone);

              const formData3 = {
                customsPermit: response.data.message,
                resstate: response2.data.message,
                createdAt: now,
              };

              await axios.post(
                `${BASE_API_URL}/outbound-svc/customspermit/resCust`,
                formData3,
                {
                  headers: { Authorization: "Bearer " + token.accessToken },
                }
              );
            } else {
              const moment = require("moment-timezone");
              const timezone = "Asia/Bangkok";
              const now = moment().tz(timezone);

              const formData3 = {
                customsPermit: response.data.message,
                resstate: response2.data.message,
                createdAt: now,
              };

              await axios.post(
                `${BASE_API_URL}/outbound-svc/customspermit/resCust`,
                formData3,
                {
                  headers: { Authorization: "Bearer " + token.accessToken },
                }
              );

              this.gridshow = false;
              setTimeout(() => {
                this.gridshow = true;
              }, 300);

              this.$vs.notify({
                position: "top-right",
                color: "success",
                title: "Success",
                text: "ส่งข้อมูล Pertmit Complete",
              });
            }
          }
        }
      } catch (error) {
        alert(error.message);
      }
    },
    async sendPermitFake5() {
      //  console.log(CUSTOMS_TOKEN);
      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

        if (token) {
          const formData = {
            number: this.recid,
            editor: String(this.userid),
          };

          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/customspermit/getPermitForResponse5`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );
          // console.log(response.data);

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Response from Backend",
              text: "No Data Found",
            });
          } else {
            const formData2 = {
              userName: CUSTOMS_User,
              password: CUSTOMS_Password,
              releasePort: 1197,
              customsPermit: response.data.message,
            };

            const response2 = await axios.post(
              `${BASE_API_URL}/outbound-svc/customspermit/customsPermitResponseFake`,
              formData2,
              {
                headers: { Authorization: "Bearer " + token.accessToken },
              }
            );

            if (response2.data != "OK") {
              this.loading = false;
              this.$vs.notify({
                position: "top-right",
                color: "danger",
                title: "Error from Backend",
                text: response2.data,
              });

              const moment = require("moment-timezone");
              const timezone = "Asia/Bangkok";
              const now = moment().tz(timezone);

              const formData3 = {
                customsPermit: response.data.message,
                resstate: response2.data,
                createdAt: now,
              };

              await axios.post(
                `${BASE_API_URL}/outbound-svc/customspermit/resCust`,
                formData3,
                {
                  headers: { Authorization: "Bearer " + token.accessToken },
                }
              );
            } else {
              const moment = require("moment-timezone");
              const timezone = "Asia/Bangkok";
              const now = moment().tz(timezone);

              const formData3 = {
                customsPermit: response.data.message,
                resstate: response2.data,
                createdAt: now,
              };

              await axios.post(
                `${BASE_API_URL}/outbound-svc/customspermit/resCust`,
                formData3,
                {
                  headers: { Authorization: "Bearer " + token.accessToken },
                }
              );

              this.gridshow = false;
              setTimeout(() => {
                this.gridshow = true;
              }, 300);

              this.$vs.notify({
                position: "top-right",
                color: "success",
                title: "Success",
                text: "ส่งข้อมูล Pertmit Complete",
              });
            }
          }
        }
      } catch (error) {
        alert(error.message);
      }
    },
    async goPreview() {
      if (this.documentType == 2 || this.documentType == 4) {
        this.goPreviewInspection();
      } else if (this.documentType == 1 || this.documentType == 6) {
        this.goPreviewPermit();
      }
    },
    async goReprint() {
      if (this.documentType == 2 || this.documentType == 4) {
        this.goReprintInspection();
      } else if (this.documentType == 1 || this.documentType == 6) {
        this.goReprintPermit();
      }
    },
    async goPreviewInspection() {
      this.contents = [];

      this.goDate();

      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        this.readonly = true;

        if (token) {
          const formData = {
            number: this.recid,
            documentType: this.documentType,
            editor: String(this.userid),
            companyGroupsCode: this.companyGroupsCode,
          };

          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/customspermit/printPreviewPermit`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );
          // console.log(response.data);

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data.message,
              time:8000,
              // fixed:true,
            });
          } else {
            const docDefinition = {
              // a string or { width: number, height: number }
              pageSize: "A4",

              // by default we use portrait, you can change it to landscape if you wish
              pageOrientation: "portrait",
              watermark: {
                text: "PREVIEW",
                color: "blue",
                opacity: 0.3,
                bold: true,
                italics: false,
              },
              content: [
                {
                  image: this.textToBase64Barcode(
                    response.data.message[0].declarationNo
                  ),
                  width: 150,
                  height: 40,
                  absolutePosition: { x: 360, y: 110 },
                },
                {
                  table: {
                    heights: 25,
                    widths: [250, 250], // 525
                    // body: this.getArray(response.data.message[il]),
                    body: [
                      [
                        {
                          border: [true, true, false, true],
                          text: "",
                          fontSize: 12,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, true, true, true],
                          text: "",
                          fontSize: 12,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                    // body: this.arData,
                  },
                },
                {
                  table: {
                    widths: [509], // 525
                    // body: this.getArray(response.data.message[il]),
                    body: [
                      [
                        {
                          border: [true, true, true, true],
                          text: "แบบสั่งการตรวจ (INSPECTION FORM)",
                          fontSize: 20,
                          bold: true,
                          alignment: "center",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                    // body: this.arData,
                  },
                },
                {
                  table: {
                    heights: 70,
                    widths: [250, 250],
                    body: [
                      [
                        [
                          {
                            border: [true, true, true, true],
                            text:
                              "Declaration No. : " +
                              response.data.message[0].declarationNo,
                            fontSize: 14,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                          {
                            border: [true, true, true, true],
                            text: "เลขที่ใบขน ",
                            fontSize: 14,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                        ],
                        {
                          border: [true, true, true, true],
                          text: response.data.message[0].declarationNo,
                          bold: true,
                          fontSize: 21,
                          alignment: "center",
                          // [left, top, right, bottom]
                          margin: [0, 42, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    heights: 40,
                    widths: [250, 250],
                    body: [
                      [
                        [
                          {
                            border: [true, true, true, true],
                            text:
                              "MAWB NO. : " + response.data.message[0].masterBL,
                            fontSize: 14,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                          {
                            border: [true, true, true, true],
                            text: "เลขที่ใบตราส่งสินค้า (Master) ",
                            fontSize: 14,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                        ],
                        [
                          {
                            border: [true, true, true, true],
                            text:
                              "HAWB NO. : " + response.data.message[0].houseBL,
                            fontSize: 14,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                          {
                            border: [true, true, true, true],
                            text: "เลขที่ใบตราส่งสินค้า (House) ",
                            fontSize: 14,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                        ],
                      ],
                    ],
                  },
                },
                {
                  table: {
                    heights: 40,
                    widths: [250, 250],
                    body: [
                      [
                        [
                          {
                            border: [true, true, true, true],
                            text:
                              "Number of package / Total Number of Package : " +
                              response.data.message[0].noOfPackage +
                              " / " +
                              response.data.message[0].noOfPackage,
                            fontSize: 13,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                          {
                            border: [true, true, true, true],
                            text: "จำนวนหีบห่อสนิค้า / จำนวนหีบห่อสินค้าทั้ง Shipment ",
                            fontSize: 14,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                        ],
                        [
                          {
                            border: [true, true, true, true],
                            text:
                              "Weight : " +
                              response.data.message[0].gossWeight +
                              " " +
                              response.data.message[0].weightUnit,
                            fontSize: 14,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                          {
                            border: [true, true, true, true],
                            text: "น้ำหนักสินค้า ",
                            fontSize: 14,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                        ],
                      ],
                    ],
                  },
                },
                {
                  table: {
                    heights: 100,
                    widths: [250, 250],
                    body: [
                      [
                        [
                          {
                            border: [true, true, true, true],
                            text:
                              "Consignee Name : " +
                              response.data.message[0].consigneeName,
                            fontSize: 13,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                        ],
                        [
                          {
                            border: [true, true, true, true],
                            text:
                              "Inspection Command : " +
                              response.data.message[0].documentType,
                            fontSize: 14,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                          {
                            border: [true, true, true, true],
                            text: "หน่วยงานที่สั่งการตรวจและสถานที่เปิดตรวจสินค้า ",
                            fontSize: 14,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                          {
                            border: [true, true, true, true],
                            text: "Multimodal Transportation Zone3 ",
                            fontSize: 14,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                        ],
                      ],
                    ],
                  },
                },
              ],
              defaultStyle: {
                // 4. default style 'THSarabunNew' font to test
                font: "THSarabunNew",
              },
              styles: {
                title: {
                  fontSize: 20,
                  bold: true,
                  alignment: "center",
                },
                header: {
                  fontSize: 18,
                  bold: true,
                  alignment: "right",
                  margin: [0, 190, 0, 80],
                },
                subheader: {
                  fontSize: 14,
                },
                superMargin: {
                  margin: [20, 0, 40, 0],
                  fontSize: 15,
                },
              },
            };

            pdfMake.vfs = pdfFonts.pdfMake.vfs; // 2. set vfs pdf font
            pdfMake.fonts = {
              // default Roboto font
              Roboto: {
                normal: "Roboto-Regular.ttf",
                bold: "Roboto-Medium.ttf",
                italics: "Roboto-Italic.ttf",
                bolditalics: "Roboto-MediumItalic.ttf",
              },
              // THSarabunNew Font
              THSarabunNew: {
                normal: "THSarabunNew.ttf",
                bold: "THSarabunNew Bold.ttf",
                italics: "THSarabunNew italic.ttf",
                bolditalics: "THSarabunNew Bolditalic.ttf",
              },
            };

            setTimeout(() => {
              pdfMake.createPdf(docDefinition).open();
            }, 1000);

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Print Complete",
              text: "Print Complete",
            });

            // if (ENV_CHECK == "PROD") {
            //   this.submitFDMS(this.recid);
            // }
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }

      // this.gridshow = false;
      // this.gridshow = true;
    },
    async goReprintInspection() {
      this.contents = [];

      this.goDate();

      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        this.readonly = true;

        if (token) {
          const formData = {
            number: this.recid,
            documentType: this.documentType,
            editor: String(this.userid),
            companyGroupsCode: this.companyGroupsCode,
          };

          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/customspermit/rePrintPermit`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );
          // console.log(response.data);

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data.message,
              time:8000,
            });
          } else {
            const docDefinition = {
              // a string or { width: number, height: number }
              pageSize: "A4",

              // by default we use portrait, you can change it to landscape if you wish
              pageOrientation: "portrait",
              // watermark: {
              //   text: "PREVIEW",
              //   color: "blue",
              //   opacity: 0.3,
              //   bold: true,
              //   italics: false,
              // },
              content: [
                {
                  image: this.textToBase64Barcode(
                    response.data.message[0].declarationNo
                  ),
                  width: 150,
                  height: 40,
                  absolutePosition: { x: 360, y: 110 },
                },
                {
                  table: {
                    heights: 25,
                    widths: [250, 250], // 525
                    // body: this.getArray(response.data.message[il]),
                    body: [
                      [
                        {
                          border: [true, true, false, true],
                          text: "",
                          fontSize: 12,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, true, true, true],
                          text: "",
                          fontSize: 12,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                    // body: this.arData,
                  },
                },
                {
                  table: {
                    widths: [509], // 525
                    // body: this.getArray(response.data.message[il]),
                    body: [
                      [
                        {
                          border: [true, true, true, true],
                          text: "แบบสั่งการตรวจ (INSPECTION FORM)",
                          fontSize: 20,
                          bold: true,
                          alignment: "center",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                    // body: this.arData,
                  },
                },
                {
                  table: {
                    heights: 70,
                    widths: [250, 250],
                    body: [
                      [
                        [
                          {
                            border: [true, true, true, true],
                            text:
                              "Declaration No. : " +
                              response.data.message[0].declarationNo,
                            fontSize: 14,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                          {
                            border: [true, true, true, true],
                            text: "เลขที่ใบขน ",
                            fontSize: 14,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                        ],
                        {
                          border: [true, true, true, true],
                          text: response.data.message[0].declarationNo,
                          bold: true,
                          fontSize: 21,
                          alignment: "center",
                          // [left, top, right, bottom]
                          margin: [0, 42, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    heights: 40,
                    widths: [250, 250],
                    body: [
                      [
                        [
                          {
                            border: [true, true, true, true],
                            text:
                              "MAWB NO. : " + response.data.message[0].masterBL,
                            fontSize: 14,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                          {
                            border: [true, true, true, true],
                            text: "เลขที่ใบตราส่งสินค้า (Master) ",
                            fontSize: 14,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                        ],
                        [
                          {
                            border: [true, true, true, true],
                            text:
                              "HAWB NO. : " + response.data.message[0].houseBL,
                            fontSize: 14,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                          {
                            border: [true, true, true, true],
                            text: "เลขที่ใบตราส่งสินค้า (House) ",
                            fontSize: 14,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                        ],
                      ],
                    ],
                  },
                },
                {
                  table: {
                    heights: 40,
                    widths: [250, 250],
                    body: [
                      [
                        [
                          {
                            border: [true, true, true, true],
                            text:
                              "Number of package / Total Number of Package : " +
                              response.data.message[0].noOfPackage +
                              " / " +
                              response.data.message[0].noOfPackage,
                            fontSize: 13,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                          {
                            border: [true, true, true, true],
                            text: "จำนวนหีบห่อสนิค้า / จำนวนหีบห่อสินค้าทั้ง Shipment ",
                            fontSize: 14,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                        ],
                        [
                          {
                            border: [true, true, true, true],
                            text:
                              "Weight : " +
                              response.data.message[0].gossWeight +
                              " " +
                              response.data.message[0].weightUnit,
                            fontSize: 14,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                          {
                            border: [true, true, true, true],
                            text: "น้ำหนักสินค้า ",
                            fontSize: 14,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                        ],
                      ],
                    ],
                  },
                },
                {
                  table: {
                    heights: 100,
                    widths: [250, 250],
                    body: [
                      [
                        [
                          {
                            border: [true, true, true, true],
                            text:
                              "Consignee Name : " +
                              response.data.message[0].consigneeName,
                            fontSize: 13,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                        ],
                        [
                          {
                            border: [true, true, true, true],
                            text:
                              "Inspection Command : " +
                              response.data.message[0].documentType,
                            fontSize: 14,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                          {
                            border: [true, true, true, true],
                            text: "หน่วยงานที่สั่งการตรวจและสถานที่เปิดตรวจสินค้า ",
                            fontSize: 14,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                          {
                            border: [true, true, true, true],
                            text: "Multimodal Transportation Zone3 ",
                            fontSize: 14,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                        ],
                      ],
                    ],
                  },
                },
              ],
              defaultStyle: {
                // 4. default style 'THSarabunNew' font to test
                font: "THSarabunNew",
              },
              styles: {
                title: {
                  fontSize: 20,
                  bold: true,
                  alignment: "center",
                },
                header: {
                  fontSize: 18,
                  bold: true,
                  alignment: "right",
                  margin: [0, 190, 0, 80],
                },
                subheader: {
                  fontSize: 14,
                },
                superMargin: {
                  margin: [20, 0, 40, 0],
                  fontSize: 15,
                },
              },
            };

            pdfMake.vfs = pdfFonts.pdfMake.vfs; // 2. set vfs pdf font
            pdfMake.fonts = {
              // default Roboto font
              Roboto: {
                normal: "Roboto-Regular.ttf",
                bold: "Roboto-Medium.ttf",
                italics: "Roboto-Italic.ttf",
                bolditalics: "Roboto-MediumItalic.ttf",
              },
              // THSarabunNew Font
              THSarabunNew: {
                normal: "THSarabunNew.ttf",
                bold: "THSarabunNew Bold.ttf",
                italics: "THSarabunNew italic.ttf",
                bolditalics: "THSarabunNew Bolditalic.ttf",
              },
            };

            setTimeout(() => {
              pdfMake.createPdf(docDefinition).open();
            }, 1000);

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Print Complete",
              text: "Print Complete",
            });

            // if (ENV_CHECK == "PROD") {
            //   this.submitFDMS(this.recid);
            // }
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }

      // this.gridshow = false;
      // this.gridshow = true;
    },
    async goReprintPermit() {
      this.contents = [];

      this.goDate();

      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        this.readonly = true;

        if (token) {
          const formData = {
            number: this.recid,
            documentType: this.documentType,
            editor: String(this.userid),
            companyGroupsCode: this.companyGroupsCode,
          };

          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/customspermit/rePrintPermit`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );
          // console.log(response.data);

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data.message,
              time:8000,
            });
          } else {
            let mark = "";
            response.data.message[0].mark == null ||
              response.data.message[0].mark == ""
              ? (mark = "-")
              : (mark = response.data.message[0].mark);
            const docDefinition = {
              // a string or { width: number, height: number }
              pageSize: "A4",

              // by default we use portrait, you can change it to landscape if you wish
              pageOrientation: "portrait",
              // watermark: {
              //   text: "PREVIEW",
              //   color: "blue",
              //   opacity: 0.3,
              //   bold: true,
              //   italics: false,
              // },
              content: [
                {
                  image: this.textToBase64Barcode(
                    response.data.message[0].declarationNo
                  ),
                  width: 150,
                  height: 40,
                  absolutePosition: { x: 360, y: 100 },
                },
                {
                  table: {
                    heights: 15,
                    widths: [250, 250], // 525
                    // body: this.getArray(response.data.message[il]),
                    body: [
                      [
                        {
                          border: [true, true, false, true],
                          text: "",
                          fontSize: 12,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, true, true, true],
                          text: "",
                          fontSize: 12,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                    // body: this.arData,
                  },
                },
                {
                  table: {
                    widths: [509], // 525
                    // body: this.getArray(response.data.message[il]),
                    body: [
                      [
                        {
                          border: [true, true, true, true],
                          text: "MultiModal Transportation CARGO PERMIT",
                          fontSize: 20,
                          bold: true,
                          alignment: "center",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                    // body: this.arData,
                  },
                },
                {
                  table: {
                    // heights: 80,
                    widths: [250, 250],
                    body: [
                      [
                        {
                          border: [true, false, false, false],
                          text:
                            "Declaration No. : " +
                            response.data.message[0].declarationNo,
                          fontSize: 12,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, false, true, false],
                          text: "",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [250, 250],
                    body: [
                      [
                        {
                          border: [true, false, false, false],
                          text: "เลขที่ใบขน ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                        {
                          border: [false, false, true, false],
                          text: "",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [250, 250],
                    body: [
                      [
                        {
                          border: [true, false, false, false],
                          text: "Truck Manifest No. : ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, false, true, false],
                          text: response.data.message[0].declarationNo,
                          bold: true,
                          fontSize: 18,
                          alignment: "center",
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [250, 250],
                    body: [
                      [
                        {
                          border: [true, false, false, false],
                          text: "เลขที่บัญชีรถบรรทุก ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -10, 0, 0],
                        },
                        {
                          border: [false, false, true, false],
                          text: "",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [250, 250],
                    body: [
                      [
                        {
                          border: [true, true, false, false],
                          text: "Truck NO./ Total Number of Truck : ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, true, true, false],
                          text: "Truck Register : ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [250, 250],
                    body: [
                      [
                        {
                          border: [true, false, false, false],
                          text: "เที่ยวที่ / เที่ยวการขนส่งทั้งหมด ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                        {
                          border: [false, false, true, false],
                          text: "ทะเบียนรถบรรทุก ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [120, 120, 251],
                    body: [
                      [
                        {
                          border: [true, true, false, false],
                          text:
                            "Flight No : " +
                            response.data.message[0].vesselName,
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, true, false, false],
                          text:
                            "Date : " + response.data.message[0].arrivalDate,
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, true, true, false],
                          text: "Permit/License No. : ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [120, 120, 251],
                    body: [
                      [
                        {
                          border: [true, false, false, false],
                          text: "หมายเลขเที่ยวบิน ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                        {
                          border: [false, false, false, false],
                          text: "วันที่นำเข้า-ส่งออก ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                        {
                          border: [false, false, true, false],
                          text: "เลขที่ใบอนุญาต ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [250, 250],
                    body: [
                      [
                        {
                          border: [true, true, false, false],
                          text:
                            "MAWB NO : " + response.data.message[0].masterBL,
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, true, true, false],
                          text: "MAWB NO : " + response.data.message[0].houseBL,
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [250, 250],
                    body: [
                      [
                        {
                          border: [true, false, false, false],
                          text: "เลขที่ใบตราส่งสินค้า (Master) ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                        {
                          border: [false, false, true, false],
                          text: "เลขที่ใบตราส่งสินค้า (Hawb) ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [250, 250],
                    body: [
                      [
                        {
                          border: [true, true, false, false],
                          text:
                            "Number of package / Total Number of Package : " +
                            response.data.message[0].noOfPackage +
                            " / " +
                            response.data.message[0].noOfPackage,
                          fontSize: 13,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, true, true, false],
                          text:
                            "Weight : " +
                            response.data.message[0].gossWeight +
                            " " +
                            response.data.message[0].weightUnit,
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [250, 250],
                    body: [
                      [
                        {
                          border: [true, false, false, false],
                          text: "จำนวนหีบห่อสินค้า / จำนวนหีบห่อสินค้าทั้ง Shipment ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                        {
                          border: [false, false, true, false],
                          text: "น้ำหนักสินค้า ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [509],
                    body: [
                      [
                        {
                          border: [true, true, true, false],
                          text: "Nature of goods : " + mark,
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [509],
                    body: [
                      [
                        {
                          border: [true, false, true, false],
                          text: "ชนิดของสินค้า  ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [509],
                    body: [
                      [
                        {
                          border: [true, true, true, false],
                          text:
                            "Consignee Name : " +
                            response.data.message[0].consigneeName,
                          fontSize: 13,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [509],
                    body: [
                      [
                        {
                          border: [true, false, true, false],
                          text: "ชื่อผู้รับสินค้า  ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [509],
                    body: [
                      [
                        {
                          border: [true, true, true, false],
                          text: "REMARK : ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [509],
                    body: [
                      [
                        {
                          border: [true, false, true, false],
                          text: "SHIPPING MARK ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [140, 100, 125, 117],
                    body: [
                      [
                        {
                          border: [true, true, false, false],
                          text: "Print By : " + response.data.wprint,
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, true, false, false],
                          text: "Page No : 1/1",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, true, false, false],
                          text: "Date : " + this.dtoday,
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, true, true, false],
                          text: "Time : " + this.cvTimeNoDate(new Date()),
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [140, 100, 125, 117],
                    body: [
                      [
                        {
                          border: [true, false, false, true],
                          text: "ผู้สั่งพิมพ์ ",
                          fontSize: 14,
                          alignment: "left",
                          margin: [0, -5, 0, 0],
                          // [left, top, right, bottom]
                        },
                        {
                          border: [false, false, false, true],
                          text: "หน้าที่",
                          fontSize: 14,
                          alignment: "left",
                          margin: [0, -5, 0, 0],
                          // [left, top, right, bottom]
                        },
                        {
                          border: [false, false, false, true],
                          text: "วันที่สั่งพิมพ์ ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                        {
                          border: [false, false, true, true],
                          text: "เวลาที่สั่งพิมพ์ ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                      ],
                    ],
                  },
                },
              ],
              defaultStyle: {
                // 4. default style 'THSarabunNew' font to test
                font: "THSarabunNew",
              },
              styles: {
                title: {
                  fontSize: 20,
                  bold: true,
                  alignment: "center",
                },
                header: {
                  fontSize: 18,
                  bold: true,
                  alignment: "right",
                  margin: [0, 190, 0, 80],
                },
                subheader: {
                  fontSize: 14,
                },
                superMargin: {
                  margin: [20, 0, 40, 0],
                  fontSize: 15,
                },
              },
            };

            pdfMake.vfs = pdfFonts.pdfMake.vfs; // 2. set vfs pdf font
            pdfMake.fonts = {
              // default Roboto font
              Roboto: {
                normal: "Roboto-Regular.ttf",
                bold: "Roboto-Medium.ttf",
                italics: "Roboto-Italic.ttf",
                bolditalics: "Roboto-MediumItalic.ttf",
              },
              // THSarabunNew Font
              THSarabunNew: {
                normal: "THSarabunNew.ttf",
                bold: "THSarabunNew Bold.ttf",
                italics: "THSarabunNew italic.ttf",
                bolditalics: "THSarabunNew Bolditalic.ttf",
              },
            };

            setTimeout(() => {
              pdfMake.createPdf(docDefinition).open();
            }, 1000);

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Print Complete",
              text: "Print Complete",
            });

            if (ENV_CHECK == "PROD") {
              this.submitFDMS(response.data.exbordersNumber);
            }
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }

      // this.gridshow = false;
      // this.gridshow = true;
    },
    async goPreviewPermit() {
      this.contents = [];

      this.goDate();

      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        this.readonly = true;

        if (token) {
          const formData = {
            number: this.recid,
            documentType: this.documentType,
            editor: String(this.userid),
            companyGroupsCode: this.companyGroupsCode,
          };

          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/customspermit/printPreviewPermit`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );
          // console.log(response.data);

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data.message,
              time:8000,
            });
          } else {
            let mark = "";
            response.data.message[0].mark == null ||
              response.data.message[0].mark == ""
              ? (mark = "-")
              : (mark = response.data.message[0].mark);
            const docDefinition = {
              // a string or { width: number, height: number }
              pageSize: "A4",

              // by default we use portrait, you can change it to landscape if you wish
              pageOrientation: "portrait",
              watermark: {
                text: "PREVIEW",
                color: "blue",
                opacity: 0.3,
                bold: true,
                italics: false,
              },
              content: [
                {
                  image: this.textToBase64Barcode(
                    response.data.message[0].declarationNo
                  ),
                  width: 150,
                  height: 40,
                  absolutePosition: { x: 360, y: 100 },
                },
                {
                  table: {
                    heights: 15,
                    widths: [250, 250], // 525
                    // body: this.getArray(response.data.message[il]),
                    body: [
                      [
                        {
                          border: [true, true, false, true],
                          text: "",
                          fontSize: 12,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, true, true, true],
                          text: "",
                          fontSize: 12,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                    // body: this.arData,
                  },
                },
                {
                  table: {
                    widths: [509], // 525
                    // body: this.getArray(response.data.message[il]),
                    body: [
                      [
                        {
                          border: [true, true, true, true],
                          text: "MultiModal Transportation CARGO PERMIT",
                          fontSize: 20,
                          bold: true,
                          alignment: "center",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                    // body: this.arData,
                  },
                },
                {
                  table: {
                    // heights: 80,
                    widths: [250, 250],
                    body: [
                      [
                        {
                          border: [true, false, false, false],
                          text:
                            "Declaration No. : " +
                            response.data.message[0].declarationNo,
                          fontSize: 12,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, false, true, false],
                          text: "",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [250, 250],
                    body: [
                      [
                        {
                          border: [true, false, false, false],
                          text: "เลขที่ใบขน ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                        {
                          border: [false, false, true, false],
                          text: "",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [250, 250],
                    body: [
                      [
                        {
                          border: [true, false, false, false],
                          text: "Truck Manifest No. : ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, false, true, false],
                          text: response.data.message[0].declarationNo,
                          bold: true,
                          fontSize: 18,
                          alignment: "center",
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [250, 250],
                    body: [
                      [
                        {
                          border: [true, false, false, false],
                          text: "เลขที่บัญชีรถบรรทุก ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -10, 0, 0],
                        },
                        {
                          border: [false, false, true, false],
                          text: "",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [250, 250],
                    body: [
                      [
                        {
                          border: [true, true, false, false],
                          text: "Truck NO./ Total Number of Truck : ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, true, true, false],
                          text: "Truck Register : ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [250, 250],
                    body: [
                      [
                        {
                          border: [true, false, false, false],
                          text: "เที่ยวที่ / เที่ยวการขนส่งทั้งหมด ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                        {
                          border: [false, false, true, false],
                          text: "ทะเบียนรถบรรทุก ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [120, 120, 251],
                    body: [
                      [
                        {
                          border: [true, true, false, false],
                          text:
                            "Flight No : " +
                            response.data.message[0].vesselName,
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, true, false, false],
                          text:
                            "Date : " + response.data.message[0].arrivalDate,
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, true, true, false],
                          text: "Permit/License No. : ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [120, 120, 251],
                    body: [
                      [
                        {
                          border: [true, false, false, false],
                          text: "หมายเลขเที่ยวบิน ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                        {
                          border: [false, false, false, false],
                          text: "วันที่นำเข้า-ส่งออก ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                        {
                          border: [false, false, true, false],
                          text: "เลขที่ใบอนุญาต ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [250, 250],
                    body: [
                      [
                        {
                          border: [true, true, false, false],
                          text:
                            "MAWB NO : " + response.data.message[0].masterBL,
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, true, true, false],
                          text: "MAWB NO : " + response.data.message[0].houseBL,
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [250, 250],
                    body: [
                      [
                        {
                          border: [true, false, false, false],
                          text: "เลขที่ใบตราส่งสินค้า (Master) ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                        {
                          border: [false, false, true, false],
                          text: "เลขที่ใบตราส่งสินค้า (Hawb) ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [250, 250],
                    body: [
                      [
                        {
                          border: [true, true, false, false],
                          text:
                            "Number of package / Total Number of Package : " +
                            response.data.message[0].noOfPackage +
                            " / " +
                            response.data.message[0].noOfPackage,
                          fontSize: 13,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, true, true, false],
                          text:
                            "Weight : " +
                            response.data.message[0].gossWeight +
                            " " +
                            response.data.message[0].weightUnit,
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [250, 250],
                    body: [
                      [
                        {
                          border: [true, false, false, false],
                          text: "จำนวนหีบห่อสินค้า / จำนวนหีบห่อสินค้าทั้ง Shipment ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                        {
                          border: [false, false, true, false],
                          text: "น้ำหนักสินค้า ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [509],
                    body: [
                      [
                        {
                          border: [true, true, true, false],
                          text: "Nature of goods : " + mark,
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [509],
                    body: [
                      [
                        {
                          border: [true, false, true, false],
                          text: "ชนิดของสินค้า  ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [509],
                    body: [
                      [
                        {
                          border: [true, true, true, false],
                          text:
                            "Consignee Name : " +
                            response.data.message[0].consigneeName,
                          fontSize: 13,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [509],
                    body: [
                      [
                        {
                          border: [true, false, true, false],
                          text: "ชื่อผู้รับสินค้า  ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [509],
                    body: [
                      [
                        {
                          border: [true, true, true, false],
                          text: "REMARK : ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [509],
                    body: [
                      [
                        {
                          border: [true, false, true, false],
                          text: "SHIPPING MARK ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [140, 100, 125, 117],
                    body: [
                      [
                        {
                          border: [true, true, false, false],
                          text: "Print By : " + response.data.wprint,
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, true, false, false],
                          text: "Page No : 1/1",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, true, false, false],
                          text: "Date : " + this.dtoday,
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, true, true, false],
                          text: "Time : " + this.cvTimeNoDate(new Date()),
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [140, 100, 125, 117],
                    body: [
                      [
                        {
                          border: [true, false, false, true],
                          text: "ผู้สั่งพิมพ์ ",
                          fontSize: 14,
                          alignment: "left",
                          margin: [0, -5, 0, 0],
                          // [left, top, right, bottom]
                        },
                        {
                          border: [false, false, false, true],
                          text: "หน้าที่",
                          fontSize: 14,
                          alignment: "left",
                          margin: [0, -5, 0, 0],
                          // [left, top, right, bottom]
                        },
                        {
                          border: [false, false, false, true],
                          text: "วันที่สั่งพิมพ์ ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                        {
                          border: [false, false, true, true],
                          text: "เวลาที่สั่งพิมพ์ ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                      ],
                    ],
                  },
                },
              ],
              defaultStyle: {
                // 4. default style 'THSarabunNew' font to test
                font: "THSarabunNew",
              },
              styles: {
                title: {
                  fontSize: 20,
                  bold: true,
                  alignment: "center",
                },
                header: {
                  fontSize: 18,
                  bold: true,
                  alignment: "right",
                  margin: [0, 190, 0, 80],
                },
                subheader: {
                  fontSize: 14,
                },
                superMargin: {
                  margin: [20, 0, 40, 0],
                  fontSize: 15,
                },
              },
            };

            pdfMake.vfs = pdfFonts.pdfMake.vfs; // 2. set vfs pdf font
            pdfMake.fonts = {
              // default Roboto font
              Roboto: {
                normal: "Roboto-Regular.ttf",
                bold: "Roboto-Medium.ttf",
                italics: "Roboto-Italic.ttf",
                bolditalics: "Roboto-MediumItalic.ttf",
              },
              // THSarabunNew Font
              THSarabunNew: {
                normal: "THSarabunNew.ttf",
                bold: "THSarabunNew Bold.ttf",
                italics: "THSarabunNew italic.ttf",
                bolditalics: "THSarabunNew Bolditalic.ttf",
              },
            };

            setTimeout(() => {
              pdfMake.createPdf(docDefinition).open();
            }, 1000);

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Print Complete",
              text: "Print Complete",
            });

            // if (ENV_CHECK == "PROD") {
            //   this.submitFDMS(this.recid);
            // }
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }

      // this.gridshow = false;
      // this.gridshow = true;
    },
    goPermits() {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: `Confirm`,
        text: "Do you want to Print Permit? หากปริ้นท์จะส่งข้อมูลไปที่กรมศุลกากรทันที ",
        accept: this.goPermit,
      });
    },
    async goPermit() {
      if (this.documentType == 2) {
        this.goSendInspection();
      } else if (this.documentType == 1) {
        // alert("1")
        this.goSendPermit();
      }
    },
    async goSendInspection() {
      
      this.contents = [];

      this.goDate();

      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        this.readonly = true;

        if (token) {
          const formData = {
            number: this.recid,
            documentType: this.documentType,
            editor: String(this.userid),
            companyGroupsCode: this.companyGroupsCode,
          };

          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/customspermit/printPreviewPermit`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );
          // console.log(response.data);

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data.message,
              time:8000,
            });

          } else {
            const docDefinition = {
              // a string or { width: number, height: number }
              pageSize: "A4",

              // by default we use portrait, you can change it to landscape if you wish
              pageOrientation: "portrait",
              content: [
                {
                  image: this.textToBase64Barcode(
                    response.data.message[0].declarationNo
                  ),
                  width: 150,
                  height: 40,
                  absolutePosition: { x: 360, y: 110 },
                },
                {
                  table: {
                    heights: 25,
                    widths: [250, 250], // 525
                    // body: this.getArray(response.data.message[il]),
                    body: [
                      [
                        {
                          border: [true, true, false, true],
                          text: "",
                          fontSize: 12,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, true, true, true],
                          text: "",
                          fontSize: 12,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                    // body: this.arData,
                  },
                },
                {
                  table: {
                    widths: [509], // 525
                    // body: this.getArray(response.data.message[il]),
                    body: [
                      [
                        {
                          border: [true, true, true, true],
                          text: "แบบสั่งการตรวจ (INSPECTION FORM)",
                          fontSize: 20,
                          bold: true,
                          alignment: "center",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                    // body: this.arData,
                  },
                },
                {
                  table: {
                    heights: 70,
                    widths: [250, 250],
                    body: [
                      [
                        [
                          {
                            border: [true, true, true, true],
                            text:
                              "Declaration No. : " +
                              response.data.message[0].declarationNo,
                            fontSize: 14,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                          {
                            border: [true, true, true, true],
                            text: "เลขที่ใบขน ",
                            fontSize: 14,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                        ],
                        {
                          border: [true, true, true, true],
                          text: response.data.message[0].declarationNo,
                          bold: true,
                          fontSize: 21,
                          alignment: "center",
                          // [left, top, right, bottom]
                          margin: [0, 42, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    heights: 40,
                    widths: [250, 250],
                    body: [
                      [
                        [
                          {
                            border: [true, true, true, true],
                            text:
                              "MAWB NO. : " + response.data.message[0].masterBL,
                            fontSize: 14,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                          {
                            border: [true, true, true, true],
                            text: "เลขที่ใบตราส่งสินค้า (Master) ",
                            fontSize: 14,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                        ],
                        [
                          {
                            border: [true, true, true, true],
                            text:
                              "HAWB NO. : " + response.data.message[0].houseBL,
                            fontSize: 14,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                          {
                            border: [true, true, true, true],
                            text: "เลขที่ใบตราส่งสินค้า (House) ",
                            fontSize: 14,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                        ],
                      ],
                    ],
                  },
                },
                {
                  table: {
                    heights: 40,
                    widths: [250, 250],
                    body: [
                      [
                        [
                          {
                            border: [true, true, true, true],
                            text:
                              "Number of package / Total Number of Package : " +
                              response.data.message[0].noOfPackage +
                              " / " +
                              response.data.message[0].noOfPackage,
                            fontSize: 13,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                          {
                            border: [true, true, true, true],
                            text: "จำนวนหีบห่อสนิค้า / จำนวนหีบห่อสินค้าทั้ง Shipment ",
                            fontSize: 14,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                        ],
                        [
                          {
                            border: [true, true, true, true],
                            text:
                              "Weight : " +
                              response.data.message[0].gossWeight +
                              " " +
                              response.data.message[0].weightUnit,
                            fontSize: 14,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                          {
                            border: [true, true, true, true],
                            text: "น้ำหนักสินค้า ",
                            fontSize: 14,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                        ],
                      ],
                    ],
                  },
                },
                {
                  table: {
                    heights: 100,
                    widths: [250, 250],
                    body: [
                      [
                        [
                          {
                            border: [true, true, true, true],
                            text:
                              "Consignee Name : " +
                              response.data.message[0].consigneeName,
                            fontSize: 13,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                        ],
                        [
                          {
                            border: [true, true, true, true],
                            text:
                              "Inspection Command : " +
                              response.data.message[0].documentType,
                            fontSize: 14,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                          {
                            border: [true, true, true, true],
                            text: "หน่วยงานที่สั่งการตรวจและสถานที่เปิดตรวจสินค้า ",
                            fontSize: 14,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                          {
                            border: [true, true, true, true],
                            text: "Multimodal Transportation Zone3 ",
                            fontSize: 14,
                            alignment: "left",
                            // [left, top, right, bottom]
                            // margin: [100, -20, 0, 0],
                          },
                        ],
                      ],
                    ],
                  },
                },
              ],
              defaultStyle: {
                // 4. default style 'THSarabunNew' font to test
                font: "THSarabunNew",
              },
              styles: {
                title: {
                  fontSize: 20,
                  bold: true,
                  alignment: "center",
                },
                header: {
                  fontSize: 18,
                  bold: true,
                  alignment: "right",
                  margin: [0, 190, 0, 80],
                },
                subheader: {
                  fontSize: 14,
                },
                superMargin: {
                  margin: [20, 0, 40, 0],
                  fontSize: 15,
                },
              },
            };

            pdfMake.vfs = pdfFonts.pdfMake.vfs; // 2. set vfs pdf font
            pdfMake.fonts = {
              // default Roboto font
              Roboto: {
                normal: "Roboto-Regular.ttf",
                bold: "Roboto-Medium.ttf",
                italics: "Roboto-Italic.ttf",
                bolditalics: "Roboto-MediumItalic.ttf",
              },
              // THSarabunNew Font
              THSarabunNew: {
                normal: "THSarabunNew.ttf",
                bold: "THSarabunNew Bold.ttf",
                italics: "THSarabunNew italic.ttf",
                bolditalics: "THSarabunNew Bolditalic.ttf",
              },
            };

            setTimeout(() => {
              pdfMake.createPdf(docDefinition).open();
            }, 1000);

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Print Complete",
              text: "Print Complete",
            });

            if (CUSTOMS_ENV == "PROD") {
              this.sendInspection();
              // alert("Permit Send");
            } else {
              this.sendInspectionFake();
              // alert("Fake Send")
            }
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }

      // this.gridshow = false;
      // this.gridshow = true;
    },
    async goSendPermit() {
      this.contents = [];

      this.goDate();

      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        this.readonly = true;

        if (token) {

          if (CUSTOMS_ENV == "PROD") {
            // alert("prod")
            this.sendPermit6();
            // this.submitFDMS(this.exbordersNumber) // ซ้ำกับ sendPermit6
            // alert("Permit Send");
          } else {
            this.sendPermitFake6();
            // alert("Fake Send");
          }

          const formData = {
            number: this.recid,
            documentType: this.documentType,
            editor: String(this.userid),
            companyGroupsCode: this.companyGroupsCode,
          };

          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/customspermit/printPreviewPermit`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );
          // console.log(response.data);

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data.message,
              time:8000,
            });
          } else {
            let mark = "";
            response.data.message[0].mark == null ||
              response.data.message[0].mark == ""
              ? (mark = "-")
              : (mark = response.data.message[0].mark);
            const docDefinition = {
              // a string or { width: number, height: number }
              pageSize: "A4",

              // by default we use portrait, you can change it to landscape if you wish
              pageOrientation: "portrait",
              content: [
                {
                  image: this.textToBase64Barcode(
                    response.data.message[0].declarationNo
                  ),
                  width: 150,
                  height: 40,
                  absolutePosition: { x: 360, y: 100 },
                },
                {
                  table: {
                    heights: 15,
                    widths: [250, 250], // 525
                    // body: this.getArray(response.data.message[il]),
                    body: [
                      [
                        {
                          border: [true, true, false, true],
                          text: "",
                          fontSize: 12,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, true, true, true],
                          text: "",
                          fontSize: 12,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                    // body: this.arData,
                  },
                },
                {
                  table: {
                    widths: [509], // 525
                    // body: this.getArray(response.data.message[il]),
                    body: [
                      [
                        {
                          border: [true, true, true, true],
                          text: "MultiModal Transportation CARGO PERMIT",
                          fontSize: 20,
                          bold: true,
                          alignment: "center",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                    // body: this.arData,
                  },
                },
                {
                  table: {
                    // heights: 80,
                    widths: [250, 250],
                    body: [
                      [
                        {
                          border: [true, false, false, false],
                          text:
                            "Declaration No. : " +
                            response.data.message[0].declarationNo,
                          fontSize: 12,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, false, true, false],
                          text: "",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [250, 250],
                    body: [
                      [
                        {
                          border: [true, false, false, false],
                          text: "เลขที่ใบขน ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                        {
                          border: [false, false, true, false],
                          text: "",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [250, 250],
                    body: [
                      [
                        {
                          border: [true, false, false, false],
                          text: "Truck Manifest No. : ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, false, true, false],
                          text: response.data.message[0].declarationNo,
                          bold: true,
                          fontSize: 18,
                          alignment: "center",
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [250, 250],
                    body: [
                      [
                        {
                          border: [true, false, false, false],
                          text: "เลขที่บัญชีรถบรรทุก ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -10, 0, 0],
                        },
                        {
                          border: [false, false, true, false],
                          text: "",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [250, 250],
                    body: [
                      [
                        {
                          border: [true, true, false, false],
                          text: "Truck NO./ Total Number of Truck : ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, true, true, false],
                          text: "Truck Register : ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [250, 250],
                    body: [
                      [
                        {
                          border: [true, false, false, false],
                          text: "เที่ยวที่ / เที่ยวการขนส่งทั้งหมด ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                        {
                          border: [false, false, true, false],
                          text: "ทะเบียนรถบรรทุก ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [120, 120, 251],
                    body: [
                      [
                        {
                          border: [true, true, false, false],
                          text:
                            "Flight No : " +
                            response.data.message[0].vesselName,
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, true, false, false],
                          text:
                            "Date : " + response.data.message[0].arrivalDate,
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, true, true, false],
                          text: "Permit/License No. : ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [120, 120, 251],
                    body: [
                      [
                        {
                          border: [true, false, false, false],
                          text: "หมายเลขเที่ยวบิน ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                        {
                          border: [false, false, false, false],
                          text: "วันที่นำเข้า-ส่งออก ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                        {
                          border: [false, false, true, false],
                          text: "เลขที่ใบอนุญาต ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [250, 250],
                    body: [
                      [
                        {
                          border: [true, true, false, false],
                          text:
                            "MAWB NO : " + response.data.message[0].masterBL,
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, true, true, false],
                          text: "HAWB NO : " + response.data.message[0].houseBL,
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [250, 250],
                    body: [
                      [
                        {
                          border: [true, false, false, false],
                          text: "เลขที่ใบตราส่งสินค้า (Master) ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                        {
                          border: [false, false, true, false],
                          text: "เลขที่ใบตราส่งสินค้า (Hawb) ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [250, 250],
                    body: [
                      [
                        {
                          border: [true, true, false, false],
                          text:
                            "Number of package / Total Number of Package : " +
                            response.data.message[0].noOfPackage +
                            " / " +
                            response.data.message[0].noOfPackage,
                          fontSize: 13,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, true, true, false],
                          text:
                            "Weight : " +
                            response.data.message[0].gossWeight +
                            " " +
                            response.data.message[0].weightUnit,
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [250, 250],
                    body: [
                      [
                        {
                          border: [true, false, false, false],
                          text: "จำนวนหีบห่อสินค้า / จำนวนหีบห่อสินค้าทั้ง Shipment ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                        {
                          border: [false, false, true, false],
                          text: "น้ำหนักสินค้า ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [509],
                    body: [
                      [
                        {
                          border: [true, true, true, false],
                          text: "Nature of goods : " + mark,
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [509],
                    body: [
                      [
                        {
                          border: [true, false, true, false],
                          text: "ชนิดของสินค้า  ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [509],
                    body: [
                      [
                        {
                          border: [true, true, true, false],
                          text:
                            "Consignee Name : " +
                            response.data.message[0].consigneeName,
                          fontSize: 13,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [509],
                    body: [
                      [
                        {
                          border: [true, false, true, false],
                          text: "ชื่อผู้รับสินค้า  ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [509],
                    body: [
                      [
                        {
                          border: [true, true, true, false],
                          text: "REMARK : ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [509],
                    body: [
                      [
                        {
                          border: [true, false, true, false],
                          text: "SHIPPING MARK ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [140, 100, 125, 117],
                    body: [
                      [
                        {
                          border: [true, true, false, false],
                          text: "Print By : " + response.data.wprint,
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, true, false, false],
                          text: "Page No : 1/1",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, true, false, false],
                          text: "Date : " + this.dtoday,
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, true, true, false],
                          text: "Time : " + this.cvTimeNoDate(new Date()),
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    widths: [140, 100, 125, 117],
                    body: [
                      [
                        {
                          border: [true, false, false, true],
                          text: "ผู้สั่งพิมพ์ ",
                          fontSize: 14,
                          alignment: "left",
                          margin: [0, -5, 0, 0],
                          // [left, top, right, bottom]
                        },
                        {
                          border: [false, false, false, true],
                          text: "หน้าที่",
                          fontSize: 14,
                          alignment: "left",
                          margin: [0, -5, 0, 0],
                          // [left, top, right, bottom]
                        },
                        {
                          border: [false, false, false, true],
                          text: "วันที่สั่งพิมพ์ ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                        {
                          border: [false, false, true, true],
                          text: "เวลาที่สั่งพิมพ์ ",
                          fontSize: 14,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, -5, 0, 0],
                        },
                      ],
                    ],
                  },
                },
              ],
              defaultStyle: {
                // 4. default style 'THSarabunNew' font to test
                font: "THSarabunNew",
              },
              styles: {
                title: {
                  fontSize: 20,
                  bold: true,
                  alignment: "center",
                },
                header: {
                  fontSize: 18,
                  bold: true,
                  alignment: "right",
                  margin: [0, 190, 0, 80],
                },
                subheader: {
                  fontSize: 14,
                },
                superMargin: {
                  margin: [20, 0, 40, 0],
                  fontSize: 15,
                },
              },
            };

            pdfMake.vfs = pdfFonts.pdfMake.vfs; // 2. set vfs pdf font
            pdfMake.fonts = {
              // default Roboto font
              Roboto: {
                normal: "Roboto-Regular.ttf",
                bold: "Roboto-Medium.ttf",
                italics: "Roboto-Italic.ttf",
                bolditalics: "Roboto-MediumItalic.ttf",
              },
              // THSarabunNew Font
              THSarabunNew: {
                normal: "THSarabunNew.ttf",
                bold: "THSarabunNew Bold.ttf",
                italics: "THSarabunNew italic.ttf",
                bolditalics: "THSarabunNew Bolditalic.ttf",
              },
            };

            setTimeout(() => {
              pdfMake.createPdf(docDefinition).open();
            }, 1000);

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Print Complete",
              text: "Print Complete",
            });

            // if (CUSTOMS_ENV == "PROD") {
            //   // alert("prod")
            //   this.sendPermit6();
            //   // this.submitFDMS(this.exbordersNumber) // ซ้ำกับ sendPermit6
            //   // alert("Permit Send");
            // } else {
            //   this.sendPermitFake6();
            //   // alert("Fake Send");
            // }
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }

      // this.gridshow = false;
      // this.gridshow = true;
    },
    async submitFDMS(ReferenceNumber) {
      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

        const formData2 = {
          number: ReferenceNumber,
          editor: String(this.userid)
        };

        const response2 = await axios.post(
          `${BASE_API_URL}/outbound-svc/cpermits/normalPermitToFDMS`,
          formData2,
          {
            headers: { Authorization: "Bearer " + token.accessToken },
          }
        );

        if (response2.data.status != "success") {
          this.loading = false;
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error from Submit to FDMS",
            text: response2.data.message,
            fixed: true,
          });
        }
        else {
          this.$vs.notify({
            position: "top-right",
            color: "success",
            title: "Success",
            text: response2.data.message,
          });
        }
      } catch (error) {
        alert("กรุณาเข้าระบบอีกครั้ง");
      }
    },
    // async submitFDMS(ReferenceNumber) {
    //   try {
    //     const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

    //     const formData2 = {
    //       number: ReferenceNumber,
    //     };

    //     const response2 = await axios.post(
    //       `${BASE_API_URL}/outbound-svc/cpermits/normalPermitToFDMS`,
    //       formData2,
    //       {
    //         headers: { Authorization: "Bearer " + token.accessToken },
    //       }
    //     );

    //     if (response2.data.status != "success") {
    //       this.loading = false;
    //       this.$vs.notify({
    //         position: "top-right",
    //         color: "danger",
    //         title: "Error from Submit to FDMS",
    //         text: response2.data.message,
    //         fixed: true,
    //       });
    //     } else {
    //       const NETBAY_TOKEN = localStorage.getItem("NETBAY_TOKEN");
    //       //  console.log(NETBAY_TOKEN);
    //       try {
    //         // console.log('netlogin');
    //         const formData3 = {
    //           transactionNo: response2.data.message.transactionNo,
    //           declarationNo: response2.data.message.declarationNo,
    //           documentType: response2.data.message.documentType,
    //           receivedControlNo: response2.data.message.receivedControlNo,
    //           callsign: response2.data.message.callsign,
    //           voyage: response2.data.message.voyage,
    //           portOfDischarge: response2.data.message.portOfDischarge,
    //           shedNo: response2.data.message.shedNo,
    //           vesselName: response2.data.message.vesselName,
    //           masterBL: response2.data.message.masterBL,
    //           houseBL: response2.data.message.houseBL,
    //           arrivalDate: response2.data.message.arrivalDate,
    //           consigneeName: response2.data.message.consigneeName,
    //           mark: response2.data.message.mark,
    //           noOfPackage: response2.data.message.noOfPackage,
    //           packageUnit: response2.data.message.packageUnit,
    //           gossWeight: response2.data.message.gossWeight,
    //           weightUnit: response2.data.message.weightUnit,
    //           clearanceDate: response2.data.message.clearanceDate,
    //           clearanceTime: response2.data.message.clearanceTime,
    //           transmitDate: response2.data.message.transmitDate,
    //           transmitTime: response2.data.message.transmitTime,
    //           containerNoArray: response2.data.message.containerNoArray,
    //           noOfContainer: response2.data.message.noOfContainer,
    //         };

    //         const response3 = await axios.post(
    //           PROX_URL + NETBAY_URL + `fz-webservice/api/receive-permit-normal`,
    //           // `https://kongapi.aotga.com/proxy-svc/https://uataotdc.netbay.co.th/fz-webservice/api/zone3-otherport`,
    //           // `https://uataotdc.netbay.co.th/fz-webservice/api/zone3-otherport`,
    //           // `/api/fz-webservice/api/zone3-otherport`,
    //           formData3,

    //           {
    //             headers: {
    //               "Content-Type": "application/json",
    //               token: NETBAY_TOKEN,
    //             },
    //           }
    //         );

    //         if (response3.status == "fail") {
    //           this.$vs.notify({
    //             position: "top-right",
    //             color: "danger",
    //             title: "Error",
    //             text: response3.message,
    //           });
    //         } else {
    //           this.$vs.notify({
    //             position: "top-right",
    //             color: "success",
    //             title: "Submit Success",
    //             text: response3.data.message,
    //           });

    //           const moment = require("moment-timezone");
    //           const timezone = "Asia/Bangkok";
    //           const now = moment().tz(timezone);

    //           const formData = {
    //             number: ReferenceNumber,
    //             code: response3.data.code,
    //             message: response3.data.message,
    //             createdAt: now,
    //           };

    //           await axios.post(
    //             `${BASE_API_URL}/outbound-svc/exborders/resFDMSOut`,
    //             formData,
    //             {
    //               headers: { Authorization: "Bearer " + token.accessToken },
    //             }
    //           );
    //         }
    //       } catch (error) {
    //         // alert("กรุณาเข้าระบบอีกครั้ง");
    //         if (error.response) {
    //           // console.log(error.response.data);
    //           // console.log(error.response.data.message);
    //           // console.log(error.response.status);
    //           // console.log(error.response.headers);
    //           if (error.response.data.message == "Token has expired.") {
    //             this.$vs.notify({
    //               position: "top-right",
    //               color: "danger",
    //               title: "Error",
    //               text: error.response.data.message,
    //             });
    //           } else {
    //             this.$vs.notify({
    //               position: "top-right",
    //               color: "danger",
    //               title: "Error",
    //               text: error.response.data.message,
    //             });

    //             const moment = require("moment-timezone");
    //             const timezone = "Asia/Bangkok";
    //             const now = moment().tz(timezone);

    //             const formData = {
    //               number: ReferenceNumber,
    //               code: error.response.data.code,
    //               message: error.response.data.message,
    //               createdAt: now,
    //             };

    //             await axios.post(
    //               `${BASE_API_URL}/outbound-svc/exborders/resFDMSOut`,
    //               formData,
    //               {
    //                 headers: { Authorization: "Bearer " + token.accessToken },
    //               }
    //             );
    //           }
    //         }
    //       }
    //     }
    //   } catch (error) {
    //     alert("กรุณาเข้าระบบอีกครั้ง");
    //   }
    // },
    getArray(data) {
      // console.log(val);
      this.arData = [];

      let i = 1;

      data.forEach((item) => {
        // item.updated_at = item.updated_at
        //   ? item.updated_at.replace(/-/g, "/")
        //   : null;
        this.arData.push([
          {
            text: i,
            fontSize: 10,
            bold: true,
            alignment: "center",
          },
          {
            text: item.dclnumber,
            fontSize: 10,
            bold: true,
            alignment: "center",
          },
          {
            text: item.importer,
            fontSize: 10,
            bold: true,
            alignment: "left",
          },
          {
            text: this.formatnumber(item.itempck) + " " + item.packagesCode,
            fontSize: 10,
            bold: true,
            alignment: "right",
          },
          {
            text: this.formatnumber(item.itemgw) + " " + item.gwunit,
            fontSize: 10,
            bold: true,
            alignment: "right",
          },
        ]);
      });
    },
    getArrayPermit(data) {
      // console.log(data);
      this.arData = [];

      // let i = 1;

      data.forEach((item) => {
        // item.updated_at = item.updated_at
        //   ? item.updated_at.replace(/-/g, "/")
        //   : null;
        this.arData.push([
          {
            text: item.remark,
            fontSize: 10,
            bold: true,
            alignment: "center",
          },
          [
            {
              text: this.formatnumber(item.itempck) + " " + item.packagesCode,
              fontSize: 10,
              bold: true,
              alignment: "right",
            },
            {
              text: this.formatnumber(item.itemgw) + " " + item.gwunit,
              fontSize: 10,
              bold: true,
              alignment: "right",
            },
          ],

          {
            text: item.edescription,
            fontSize: 10,
            bold: true,
            alignment: "left",
          },
          {
            text: "",
            fontSize: 10,
            bold: true,
            alignment: "left",
          },
          // {
          //   text: this.formatnumber(item.itemgw) + " " + item.gwunit,
          //   fontSize: 10,
          //   bold: true,
          //   alignment: "right",
          // },
        ]);

        // i++;
        // console.log(i);
      });
    },
    goDate() {
      let today = new Date();
      let dd = today.getDate();

      let mm = today.getMonth() + 1;
      let yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }

      if (mm < 10) {
        mm = "0" + mm;
      }
      this.daday = dd;
      this.damonth = mm;
      this.dayear = Number(yyyy) + 543;
      this.dtoday = dd + "-" + mm + "-" + this.dayear;
    },
    formatnumber(number) {
      return number.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    getXY(event) {
      this.curX = event.clientX;
      this.curY = event.clientY;

      // console.log(this.curX);
      // console.log(this.curY);
    },
    hideFab() {
      this.btndis = false;
    },
    async fdmsLogin() {
      try {
        const formData2 = {
          username: NETBAY_User,
          password: NETBAY_Password,
          companyCode: NETBAY_Companycode,
        };

        const response2 = await axios.post(
          PROX_URL + NETBAY_URL + `fz-webservice/api/auth`,
          // `https://kongapi.aotga.com/proxy-svc/https://uataotdc.netbay.co.th/fz-webservice/api/auth`,
          // `https://uataotdc.netbay.co.th/fz-webservice/api/auth`,
          // `/api/fz-webservice/api/auth`,
          formData2,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        // console.log(response2.data.data);
        if (response2.data) {
          localStorage.setItem("NETBAY_TOKEN", response2.data.data);
        }
      } catch (error) {
        // alert("กรุณาเข้าระบบอีกครั้ง");
        if (error.response) {
          // console.log(error.response.data);
          // console.log(error.response.data.message);
          // console.log(error.response.status);
          // console.log(error.response.headers);
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error",
            text: error.response.data.message,
          });
        }
      }
    },
    async customsLogin() {
      try {
        const formData2 = new URLSearchParams();
        formData2.append("grant_type", CUSTOMS_GRANT_TYPE);
        formData2.append("client_id", CUSTOMS_CLIENT_ID);
        formData2.append("client_secret", CUSTOMS_CLIENT_SECRET);
        formData2.append("scope", CUSTOMS_CLIENT_SCOPE);

        // const formData2 = {
        //   grant_type: CUSTOMS_GRANT_TYPE,
        //   client_id: CUSTOMS_CLIENT_ID,
        //   client_secret: CUSTOMS_CLIENT_SECRET,
        //   scope: CUSTOMS_CLIENT_SCOPE,
        // };

        const response2 = await axios.post(
          CUSTOMS_AUTH + `oauth2/token`,
          // `https://kongapi.aotga.com/proxy-svc/https://uataotdc.netbay.co.th/fz-webservice/api/auth`,
          // `https://uataotdc.netbay.co.th/fz-webservice/api/auth`,
          // `/api/fz-webservice/api/auth`,
          formData2,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );

        // console.log(response2.data.access_token);
        if (response2.data.access_token) {
          localStorage.setItem("CUSTOMS_TOKEN", response2.data.access_token);
        }
      } catch (error) {
        // alert("กรุณาเข้าระบบอีกครั้ง");
        if (error.response) {
          // console.log(error.response.data);
          // console.log(error.response.data.message);
          // console.log(error.response.status);
          // console.log(error.response.headers);
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error From Customs",
            text: error.response.data.error,
          });
        }
      }
    },
    async customsLoginNew() {
      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

        if (token) {
          const formData = {
            searchval: "",
          };

          const response = await axios.post(
            `${BASE_API_URL}/queue-svc/jqueue/getCustomsKey`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          if (response.data.status == 'error') {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              // color: "danger",
              title: "Error from Backend",
              text: response.data.message,
            });
          } else {
            localStorage.setItem("CUSTOMS_TOKEN", response.data.message);
          }
        }
      } catch (error) {
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // await this.$router.replace("/pages/login/");
      }
    },
    async checkProfiles() {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        const decoded = JSON.parse(
          Buffer.from(token.accessToken.split(".")[1], "base64").toString()
        );

        // console.log(decoded);

        try {
          // console.log(responseponse.data);
          this.userid = decoded.userId;
          this.userRole = decoded.userRole;

          this.businessPartnersCode = decoded.businessPartnersCode;
          this.companyGroupsCode = decoded.companyGroupsCode;
        } catch (error) {
          alert("กรุณาเข้าระบบอีกครั้ง");
          await this.$router.replace("/");
        }
      } else {
        alert("กรุณาเข้าระบบอีกครั้ง");
        await this.$router.replace("/");
      }
    },
  },
  async beforeCreate() {
    try {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      this.loading = true;

      if (token) {
        const formData = {
          searchval: "",
        };

        const response = await axios.post(
          `${BASE_API_URL}/outbound-svc/businesspartners/getShipping`,
          formData,
          {
            headers: { Authorization: "Bearer " + token.accessToken },
          }
        );

        if (!response.data) {
          this.loading = false;
          this.$vs.notify({
            position: "top-right",
            // color: "danger",
            title: "Error from Backend",
            text: response.data,
          });
        } else {
          this.loading = false;
          // console.log(response.data)
          this.ships = response.data;
        }
      }
    } catch (error) {
      this.loading = false;
      // throw error;
      alert("กรุณาเข้าระบบอีกครั้ง");
      // await this.$router.replace("/pages/login/");
    }
  },
  mounted() {
    this.checkProfiles();
    // console.log(this.$acl.check('admin'));
    // console.log(this.$store.state.reportgrid)
    // this.fdmsLogin();
    // this.customsLogin();
    this.customsLoginNew();
  },

  components: {
    aggrid,
    exbupload,
    exbadd,
    cpview,
    // CustomNotify 
  },
};
</script>

<style scoped>
.fab-wrapper {
  position: fixed;
  left: 100px;
  top: 500px;
  z-index: 5;
  display: flex;
  flex-direction: center;
  align-items: center;
}

.fab {
  background-color: rgb(231, 55, 55);
}
</style>
